/* eslint-disable react/style-prop-object */
/* eslint-disable react/no-unknown-property */
/* eslint-disable import/prefer-default-export */
export const DocIcons = {
  rename: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_827_3354)">
        <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" />
        <path
          d="M9 7.00098H6C5.46957 7.00098 4.96086 7.21169 4.58579 7.58676C4.21071 7.96184 4 8.47054 4 9.00098V18.001C4 18.5314 4.21071 19.0401 4.58579 19.4152C4.96086 19.7903 5.46957 20.001 6 20.001H15C15.5304 20.001 16.0391 19.7903 16.4142 19.4152C16.7893 19.0401 17 18.5314 17 18.001V15.001"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 15.001H12L20.5 6.50096C20.8978 6.10313 21.1213 5.56357 21.1213 5.00096C21.1213 4.43835 20.8978 3.89878 20.5 3.50096C20.1022 3.10313 19.5626 2.87964 19 2.87964C18.4374 2.87964 17.8978 3.10313 17.5 3.50096L9 12.001V15.001Z"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_827_3354">
          <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  ),
  download: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_827_2667)">
        <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" />
        <path
          d="M3.99988 17.001V19.001C3.99988 19.5314 4.21059 20.0401 4.58566 20.4152C4.96074 20.7903 5.46944 21.001 5.99988 21.001H17.9999C18.5303 21.001 19.039 20.7903 19.4141 20.4152C19.7892 20.0401 19.9999 19.5314 19.9999 19.001V17.001"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.99988 11.001L11.9999 16.001L16.9999 11.001"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 4.00098V16.001"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_827_2667">
          <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  ),
  share: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_827_3336)">
        <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" />
        <path
          d="M6 15.001C7.65685 15.001 9 13.6578 9 12.001C9 10.3441 7.65685 9.00098 6 9.00098C4.34315 9.00098 3 10.3441 3 12.001C3 13.6578 4.34315 15.001 6 15.001Z"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 9.00098C19.6569 9.00098 21 7.65783 21 6.00098C21 4.34412 19.6569 3.00098 18 3.00098C16.3431 3.00098 15 4.34412 15 6.00098C15 7.65783 16.3431 9.00098 18 9.00098Z"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 21.001C19.6569 21.001 21 19.6578 21 18.001C21 16.3441 19.6569 15.001 18 15.001C16.3431 15.001 15 16.3441 15 18.001C15 19.6578 16.3431 21.001 18 21.001Z"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.69995 10.701L15.3 7.30103"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.69995 13.301L15.3 16.701"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_827_3336">
          <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  ),
  public: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_827_4298)">
        <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" />
        <path
          d="M12 21.001C16.9706 21.001 21 16.9715 21 12.001C21 7.03041 16.9706 3.00098 12 3.00098C7.02944 3.00098 3 7.03041 3 12.001C3 16.9715 7.02944 21.001 12 21.001Z"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.59998 9.00098H20.4"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.59998 15.001H20.4"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5002 3.00098C9.8155 5.70059 8.92236 8.81884 8.92236 12.001C8.92236 15.1831 9.8155 18.3014 11.5002 21.001"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 3.00098C14.1847 5.70059 15.0778 8.81884 15.0778 12.001C15.0778 15.1831 14.1847 18.3014 12.5 21.001"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_827_4298">
          <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  ),
  delete: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_827_2630)">
        <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" />
        <path
          d="M4 7.00098H20"
          stroke="#D92929"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11.001V17.001"
          stroke="#D92929"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 11.001V17.001"
          stroke="#D92929"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 7.00098L6 19.001C6 19.5314 6.21071 20.0401 6.58579 20.4152C6.96086 20.7903 7.46957 21.001 8 21.001H16C16.5304 21.001 17.0391 20.7903 17.4142 20.4152C17.7893 20.0401 18 19.5314 18 19.001L19 7.00098"
          stroke="#D92929"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 7.00098V4.00098C9 3.73576 9.10536 3.48141 9.29289 3.29387C9.48043 3.10633 9.73478 3.00098 10 3.00098H14C14.2652 3.00098 14.5196 3.10633 14.7071 3.29387C14.8946 3.48141 15 3.73576 15 4.00098V7.00098"
          stroke="#D92929"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_827_2630">
          <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  ),
  lock: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_825_570)">
        <rect width="24" height="24" fill="white" />
        <path
          d="M17 11H7C5.89543 11 5 11.8954 5 13V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V13C19 11.8954 18.1046 11 17 11Z"
          stroke="#FC8543"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
          stroke="#FC8543"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7V11"
          stroke="#FC8543"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_825_570">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  folder: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="url(#pattern0_825_517)" />
      <defs>
        <pattern id="pattern0_825_517" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_825_517" transform="scale(0.00195312)" />
        </pattern>
        <image
          id="image0_825_517"
          width="512"
          height="512"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  ),
  backArrow: (
    <svg width="39" height="32" viewBox="0 0 39 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="39" height="32" rx="4" fill="#ECECEC" />
      <g clip-path="url(#clip0_856_18314)">
        <path
          d="M12 12L8 16L12 20"
          stroke="#5C5C5C"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <g clip-path="url(#clip1_856_18314)">
        <path
          d="M21 12.6666V10.9999C21 10.5579 21.2107 10.134 21.5858 9.82141C21.9609 9.50885 22.4696 9.33325 23 9.33325H27C27.5304 9.33325 28.0391 9.50885 28.4142 9.82141C28.7893 10.134 29 10.5579 29 10.9999V12.6666"
          stroke="#5C5C5C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.375 11.8333H30.625C31.6605 11.8333 32.5 12.6368 32.5 13.6281V21.705C32.5 22.6963 31.6605 23.4999 30.625 23.4999H19.375C18.3395 23.4999 17.5 22.6963 17.5 21.705V13.6281C17.5 12.6368 18.3395 11.8333 19.375 11.8333ZM21.5355 19.262C21.347 18.807 21.25 18.3194 21.25 17.8269C21.25 16.8323 21.6451 15.8785 22.3483 15.1753C23.0516 14.472 24.0054 14.0769 25 14.0769C25.9946 14.0769 26.9484 14.472 27.6517 15.1753C28.3549 15.8785 28.75 16.8323 28.75 17.8269C28.75 18.3194 28.653 18.807 28.4645 19.262C28.2761 19.7169 27.9999 20.1303 27.6517 20.4786C27.3034 20.8268 26.89 21.103 26.4351 21.2915C25.9801 21.4799 25.4925 21.5769 25 21.5769C24.5075 21.5769 24.0199 21.4799 23.5649 21.2915C23.11 21.103 22.6966 20.8268 22.3483 20.4786C22.0001 20.1303 21.7239 19.7169 21.5355 19.262Z"
          fill="#5C5C5C"
        />
        <path
          d="M25 16.4705H25.0042"
          stroke="#5C5C5C"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.5833 17.8989H24.9999V19.8039H25.4166"
          stroke="#5C5C5C"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_856_18314">
          <rect x="4" y="4" width="11" height="24" rx="4" fill="white" />
        </clipPath>
        <clipPath id="clip1_856_18314">
          <rect width="20" height="20" fill="white" transform="translate(15 6)" />
        </clipPath>
      </defs>
    </svg>
  ),
  add: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_856_18297)">
        <path
          d="M13.1854 7.8522H2.81455M8 2.66675V13.0376V2.66675Z"
          stroke="#3B3B3C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_856_18297">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  plus: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="add Dark">
        <path
          id="Vector"
          d="M26.3709 15.7042H5.6291M16 5.33325V26.0751V5.33325Z"
          stroke="#080808"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  ),
  upload: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66663 11.3333V12.6666C2.66663 13.0202 2.8071 13.3593 3.05715 13.6094C3.3072 13.8594 3.64634 13.9999 3.99996 13.9999H12C12.3536 13.9999 12.6927 13.8594 12.9428 13.6094C13.1928 13.3593 13.3333 13.0202 13.3333 12.6666V11.3333"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66663 6.00008L7.99996 2.66675L11.3333 6.00008"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 2.66675V10.6667"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  uploadDark: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Upload">
        <path
          id="Vector"
          d="M2.91699 11.3333V12.6666C2.91699 13.0202 3.05747 13.3593 3.30752 13.6094C3.55756 13.8594 3.8967 13.9999 4.25033 13.9999H12.2503C12.6039 13.9999 12.9431 13.8594 13.1931 13.6094C13.4432 13.3593 13.5837 13.0202 13.5837 12.6666V11.3333"
          stroke="#FC8543"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M4.91699 6.00008L8.25032 2.66675L11.5837 6.00008"
          stroke="#FC8543"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_3"
          d="M8.25 2.66675V10.6667"
          stroke="#FC8543"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  ),
  uploadBlack: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M5.3335 22.6667V25.3334C5.3335 26.0407 5.61445 26.7189 6.11454 27.219C6.61464 27.7191 7.29292 28.0001 8.00016 28.0001H24.0002C24.7074 28.0001 25.3857 27.7191 25.8858 27.219C26.3859 26.7189 26.6668 26.0407 26.6668 25.3334V22.6667"
        stroke="#080808"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.3335 11.9999L16.0002 5.33325L22.6668 11.9999"
        stroke="#080808"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 5.33325V21.3332"
        stroke="#080808"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  home: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <g clip-path="url(#clip0_825_462)">
        <path
          d="M3.75 9H2.25L9 2.25L15.75 9H14.25"
          stroke="#5C5C5C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 9V14.25C3.75 14.6478 3.90804 15.0294 4.18934 15.3107C4.47064 15.592 4.85218 15.75 5.25 15.75H12.75C13.1478 15.75 13.5294 15.592 13.8107 15.3107C14.092 15.0294 14.25 14.6478 14.25 14.25V9"
          stroke="#5C5C5C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 9H10.5V12H7.5V9Z"
          stroke="#5C5C5C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_825_462">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  edit: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M11.9999 9.33325H7.99992C7.29267 9.33325 6.6144 9.6142 6.1143 10.1143C5.6142 10.6144 5.33325 11.2927 5.33325 11.9999V23.9999C5.33325 24.7072 5.6142 25.3854 6.1143 25.8855C6.6144 26.3856 7.29267 26.6666 7.99992 26.6666H19.9999C20.7072 26.6666 21.3854 26.3856 21.8855 25.8855C22.3856 25.3854 22.6666 24.7072 22.6666 23.9999V19.9999"
        stroke="#080808"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 19.9999H16L27.3333 8.66656C27.8638 8.13613 28.1618 7.41671 28.1618 6.66656C28.1618 5.91642 27.8638 5.19699 27.3333 4.66656C26.8029 4.13613 26.0835 3.83813 25.3333 3.83813C24.5832 3.83813 23.8638 4.13613 23.3333 4.66656L12 15.9999V19.9999Z"
        stroke="#080808"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3333 6.66675L25.3332 10.6667"
        stroke="#080808"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  clip: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_825_4461)">
        <path
          d="M10.0003 4.66656L5.66696 8.99989C5.40174 9.26511 5.25274 9.62482 5.25274 9.99989C5.25274 10.375 5.40174 10.7347 5.66696 10.9999C5.93217 11.2651 6.29188 11.4141 6.66696 11.4141C7.04203 11.4141 7.40174 11.2651 7.66696 10.9999L12.0003 6.66656C12.5307 6.13613 12.8287 5.41671 12.8287 4.66656C12.8287 3.91642 12.5307 3.19699 12.0003 2.66656C11.4699 2.13613 10.7504 1.83813 10.0003 1.83813C9.25015 1.83813 8.53072 2.13613 8.00029 2.66656L3.66696 6.99989C2.87131 7.79554 2.42432 8.87468 2.42432 9.99989C2.42432 11.1251 2.87131 12.2042 3.66696 12.9999C4.46261 13.7955 5.54174 14.2425 6.66696 14.2425C7.79218 14.2425 8.87131 13.7955 9.66696 12.9999L14.0003 8.66656"
          stroke="#5C5C5C"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_825_4461">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  action: (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <g clipPath="url(#clip0_7907_35839)">
        <path
          d="M11.0124 9.99992C11.0124 9.53968 10.6393 9.16659 10.179 9.16659C9.7188 9.16659 9.3457 9.53968 9.3457 9.99992C9.3457 10.4602 9.7188 10.8333 10.179 10.8333C10.6393 10.8333 11.0124 10.4602 11.0124 9.99992Z"
          fill="#080808"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.8459 9.99992C16.8459 9.53968 16.4728 9.16659 16.0125 9.16659C15.5523 9.16659 15.1792 9.53968 15.1792 9.99992C15.1792 10.4602 15.5523 10.8333 16.0125 10.8333C16.4728 10.8333 16.8459 10.4602 16.8459 9.99992Z"
          fill="#080808"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.17936 9.99992C5.17936 9.53968 4.80627 9.16659 4.34603 9.16659C3.88579 9.16659 3.5127 9.53968 3.5127 9.99992C3.5127 10.4602 3.88579 10.8333 4.34603 10.8333C4.80627 10.8333 5.17936 10.4602 5.17936 9.99992Z"
          fill="#080808"
          stroke="#080808"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7907_35839">
          <rect width="20" height="20" fill="white" transform="matrix(0 -1 1 0 0.179199 20)" />
        </clipPath>
      </defs>
    </svg>
  ),
  confirm_delete: (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
      <path
        d="M30 52.5C42.4264 52.5 52.5 42.4264 52.5 30C52.5 17.5736 42.4264 7.5 30 7.5C17.5736 7.5 7.5 17.5736 7.5 30C7.5 42.4264 17.5736 52.5 30 52.5Z"
        stroke="#D92929"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M37.5 22.5176L22.5 37.4827M22.5 22.5176L37.5 37.4827L22.5 22.5176Z"
        stroke="#D92929"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  arrow_left: (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M20.6665 6.66663L11.3332 16L20.6665 25.3333"
        stroke="#080808"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  noData: (
    <svg
      width="385"
      height="258"
      viewBox="0 0 385 258"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6960_94997)">
        <path
          d="M175.011 21.7044C172.514 19.1935 168.462 19.1892 165.959 21.6959C165.772 21.8834 165.603 22.0808 165.444 22.2838C163.179 20.9106 160.752 19.9097 158.25 19.2851C158.281 19.0285 158.302 18.7705 158.303 18.5055C158.308 14.9569 155.445 12.078 151.91 12.0752C148.374 12.0724 145.505 14.9456 145.501 18.4942C145.501 18.7592 145.52 19.0172 145.551 19.2738C143.048 19.8941 140.618 20.8909 138.35 22.2599C138.191 22.0568 138.024 21.8581 137.837 21.672C135.34 19.161 131.287 19.1568 128.784 21.6635C126.281 24.1702 126.276 28.239 128.773 30.7499C128.959 30.9374 129.157 31.1052 129.359 31.2645C127.989 33.5399 126.992 35.9747 126.369 38.4871C126.113 38.456 125.856 38.4349 125.592 38.4349C122.056 38.4321 119.187 41.3053 119.183 44.8539C119.178 48.4024 122.041 51.2813 125.576 51.2841C125.84 51.2841 126.097 51.2644 126.353 51.2334C126.97 53.7457 127.963 56.1847 129.325 58.4616C129.123 58.6209 128.925 58.7887 128.738 58.9762C126.235 61.4829 126.229 65.5517 128.727 68.0626C131.224 70.5735 135.276 70.5778 137.779 68.0711C137.966 67.8836 138.135 67.6862 138.294 67.4832C140.559 68.8563 142.986 69.8573 145.488 70.4819C145.457 70.7385 145.436 70.9965 145.435 71.2615C145.43 74.8101 148.293 77.689 151.828 77.6918C155.364 77.6946 158.233 74.8214 158.237 71.2728C158.237 71.0078 158.218 70.7498 158.187 70.4932C160.69 69.8728 163.12 68.8761 165.388 67.5071C165.547 67.7101 165.714 67.9089 165.901 68.095C168.398 70.606 172.451 70.6102 174.954 68.1035C177.457 65.5968 177.462 61.528 174.965 59.0171C174.779 58.8296 174.581 58.6618 174.379 58.5025C175.749 56.227 176.746 53.7922 177.369 51.2799C177.625 51.3109 177.882 51.3321 178.146 51.3321C181.682 51.3349 184.551 48.4617 184.555 44.9131C184.56 41.3645 181.697 38.4857 178.162 38.4828C177.898 38.4828 177.641 38.5026 177.385 38.5336C176.767 36.0213 175.775 33.5822 174.411 31.3054C174.614 31.146 174.812 30.9783 174.998 30.7908C177.501 28.2841 177.507 24.2153 175.01 21.7044H175.011ZM160.285 36.4541C164.922 41.1178 164.912 48.6731 160.264 53.3284C155.616 57.9837 148.089 57.9766 143.453 53.3129C138.816 48.6492 138.826 41.0939 143.474 36.4386C148.122 31.7833 155.649 31.7903 160.285 36.4541Z"
          fill="#FFEBE0"
        />
        <path
          d="M362.871 236.212V56.6684C362.871 50.1592 357.606 44.8835 351.111 44.8835H117.155C110.66 44.8835 105.396 50.1606 105.396 56.6684V224.428C105.396 230.937 110.66 236.212 117.155 236.212H362.871Z"
          fill="white"
        />
        <path
          d="M362.871 236.523C362.699 236.523 362.562 236.383 362.562 236.212V56.6684C362.562 50.3411 357.425 45.1938 351.111 45.1938H117.155C110.841 45.1938 105.704 50.3411 105.704 56.6684V224.428C105.704 230.755 110.841 235.902 117.155 235.902C117.326 235.902 117.464 236.042 117.464 236.212C117.464 236.383 117.325 236.523 117.155 236.523C110.5 236.523 105.085 231.096 105.085 224.426V56.6684C105.085 49.9985 110.5 44.572 117.155 44.572H351.111C357.766 44.572 363.181 49.9985 363.181 56.6684V236.212C363.181 236.384 363.042 236.523 362.872 236.523H362.871Z"
          fill="#3B3B3C"
        />
        <path
          d="M350.173 231.739H117.155C113.132 231.739 109.859 228.458 109.859 224.426V56.6684C109.859 52.6363 113.132 49.3556 117.155 49.3556H351.112C355.134 49.3556 358.408 52.6363 358.408 56.6684V223.486C358.408 228.037 354.714 231.739 350.173 231.739ZM117.155 49.9773C113.473 49.9773 110.479 52.9789 110.479 56.6684V224.428C110.479 228.117 113.473 231.119 117.155 231.119H350.173C354.373 231.119 357.789 227.696 357.789 223.487V56.6684C357.789 52.9789 354.794 49.9773 351.112 49.9773H117.155Z"
          fill="#3B3B3C"
        />
        <path
          d="M344.008 254.89H59.2544C48.8365 254.89 40.3906 246.413 40.3906 235.956H362.871C362.871 246.413 354.425 254.89 344.007 254.89H344.008Z"
          fill="white"
        />
        <path
          d="M344.009 255.202H59.2548C48.6824 255.202 40.082 246.569 40.082 235.957C40.082 235.785 40.2211 235.647 40.391 235.647H362.871C363.042 235.647 363.18 235.787 363.18 235.957C363.18 246.569 354.58 255.202 344.007 255.202H344.009ZM40.7043 236.267C40.87 246.393 49.129 254.58 59.2562 254.58H344.01C354.137 254.58 362.395 246.393 362.562 236.267H40.7043Z"
          fill="#3B3B3C"
        />
        <path
          d="M154.806 86.8995H124.686C123.851 86.8995 123.175 87.5787 123.175 88.4165V94.7312C123.175 95.569 123.851 96.2482 124.686 96.2482H154.806C155.641 96.2482 156.318 95.569 156.318 94.7312V88.4165C156.318 87.5787 155.641 86.8995 154.806 86.8995Z"
          fill="#FFDBC6"
        />
        <path
          d="M124.352 108.837H154.472C155.307 108.837 155.984 109.516 155.984 110.354V116.667C155.984 117.504 155.307 118.184 154.472 118.184H124.352C123.518 118.184 122.841 117.504 122.841 116.667V110.354C122.841 109.516 123.518 108.837 124.352 108.837Z"
          fill="#FFDBC6"
        />
        <path
          d="M154.472 128.78H124.352C123.517 128.78 122.841 129.459 122.841 130.297V136.612C122.841 137.45 123.517 138.129 124.352 138.129H154.472C155.307 138.129 155.984 137.45 155.984 136.612V130.297C155.984 129.459 155.307 128.78 154.472 128.78Z"
          fill="#FFDBC6"
        />
        <path
          d="M243.831 86.8995H175.463C174.628 86.8995 173.951 87.5787 173.951 88.4165V94.7312C173.951 95.569 174.628 96.2482 175.463 96.2482H243.831C244.666 96.2482 245.343 95.569 245.343 94.7312V88.4165C245.343 87.5787 244.666 86.8995 243.831 86.8995Z"
          fill="#FFDBC6"
        />
        <path
          d="M203.902 108.837H175.129C174.294 108.837 173.617 109.516 173.617 110.354V116.668C173.617 117.506 174.294 118.185 175.129 118.185H203.902C204.736 118.185 205.413 117.506 205.413 116.668V110.354C205.413 109.516 204.736 108.837 203.902 108.837Z"
          fill="#FFDBC6"
        />
        <path
          d="M219.758 128.78H175.129C174.294 128.78 173.617 129.459 173.617 130.297V136.612C173.617 137.45 174.294 138.129 175.129 138.129H219.758C220.593 138.129 221.27 137.45 221.27 136.612V130.297C221.27 129.459 220.593 128.78 219.758 128.78Z"
          fill="#FFDBC6"
        />
        <path
          d="M154.806 149.097H124.686C123.851 149.097 123.175 149.776 123.175 150.614V156.929C123.175 157.767 123.851 158.446 124.686 158.446H154.806C155.641 158.446 156.318 157.767 156.318 156.929V150.614C156.318 149.776 155.641 149.097 154.806 149.097Z"
          fill="#FFDBC6"
        />
        <path
          d="M275.585 149.097H175.463C174.628 149.097 173.951 149.776 173.951 150.614V156.929C173.951 157.767 174.628 158.446 175.463 158.446H275.585C276.42 158.446 277.096 157.767 277.096 156.929V150.614C277.096 149.776 276.42 149.097 275.585 149.097Z"
          fill="#FFDBC6"
        />
        <path
          d="M345.239 149.097H286.45C285.615 149.097 284.938 149.776 284.938 150.614V156.929C284.938 157.767 285.615 158.446 286.45 158.446H345.239C346.074 158.446 346.751 157.767 346.751 156.929V150.614C346.751 149.776 346.074 149.097 345.239 149.097Z"
          fill="#FFDBC6"
        />
        <path
          d="M345.237 86.8995H254.043C253.208 86.8995 252.531 87.5787 252.531 88.4165V94.7312C252.531 95.569 253.208 96.2482 254.043 96.2482H345.237C346.072 96.2482 346.749 95.569 346.749 94.7312V88.4165C346.749 87.5787 346.072 86.8995 345.237 86.8995Z"
          fill="#FFDBC6"
        />
        <path
          d="M298.777 108.837H214.766C213.932 108.837 213.255 109.516 213.255 110.354V116.668C213.255 117.506 213.932 118.185 214.766 118.185H298.777C299.611 118.185 300.288 117.506 300.288 116.668V110.354C300.288 109.516 299.611 108.837 298.777 108.837Z"
          fill="#FFDBC6"
        />
        <path
          d="M318.852 128.78H230.621C229.786 128.78 229.109 129.459 229.109 130.297V136.612C229.109 137.45 229.786 138.129 230.621 138.129H318.852C319.687 138.129 320.363 137.45 320.363 136.612V130.297C320.363 129.459 319.687 128.78 318.852 128.78Z"
          fill="#FFDBC6"
        />
        <path
          d="M125.021 169.677H155.141C155.976 169.677 156.653 170.356 156.653 171.194V177.507C156.653 178.344 155.976 179.024 155.141 179.024H125.021C124.187 179.024 123.51 178.344 123.51 177.507V171.194C123.51 170.356 124.187 169.677 125.021 169.677Z"
          fill="#FFDBC6"
        />
        <path
          d="M155.44 187.892H125.32C124.485 187.892 123.809 188.571 123.809 189.409V195.723C123.809 196.561 124.485 197.24 125.32 197.24H155.44C156.275 197.24 156.951 196.561 156.951 195.723V189.409C156.951 188.571 156.275 187.892 155.44 187.892Z"
          fill="#FFDBC6"
        />
        <path
          d="M275.918 169.677H175.796C174.961 169.677 174.284 170.356 174.284 171.194V177.508C174.284 178.346 174.961 179.025 175.796 179.025H275.918C276.753 179.025 277.429 178.346 277.429 177.508V171.194C277.429 170.356 276.753 169.677 275.918 169.677Z"
          fill="#FFDBC6"
        />
        <path
          d="M220.726 187.892H176.096C175.262 187.892 174.585 188.571 174.585 189.409V195.723C174.585 196.561 175.262 197.24 176.096 197.24H220.726C221.561 197.24 222.237 196.561 222.237 195.723V189.409C222.237 188.571 221.561 187.892 220.726 187.892Z"
          fill="#FFDBC6"
        />
        <path
          d="M345.572 169.677H286.783C285.948 169.677 285.271 170.356 285.271 171.194V177.508C285.271 178.346 285.948 179.025 286.783 179.025H345.572C346.407 179.025 347.084 178.346 347.084 177.508V171.194C347.084 170.356 346.407 169.677 345.572 169.677Z"
          fill="#FFDBC6"
        />
        <path
          d="M319.82 187.892H231.588C230.754 187.892 230.077 188.571 230.077 189.409V195.723C230.077 196.561 230.754 197.24 231.588 197.24H319.82C320.654 197.24 321.331 196.561 321.331 195.723V189.409C321.331 188.571 320.654 187.892 319.82 187.892Z"
          fill="#FFDBC6"
        />
        <path
          d="M190.259 67.6214C190.252 67.252 190.248 66.8854 190.249 66.5132C190.268 52.859 195.581 40.0281 205.214 30.3848C214.847 20.7415 227.642 15.4419 241.247 15.4603C254.851 15.4786 267.634 20.812 277.242 30.4806C286.849 40.1493 292.129 52.9915 292.112 66.6486C292.076 94.8368 269.197 117.74 241.114 117.702C213.401 117.665 190.814 95.2979 190.261 67.6214H190.259ZM285.599 65.5616C285.367 53.9685 280.783 43.1029 272.623 34.8666C264.235 26.3992 253.074 21.727 241.197 21.7101C216.677 21.6762 196.703 41.7325 196.673 66.4188C196.646 91.1036 216.564 111.218 241.084 111.252C265.604 111.285 285.578 91.2291 285.609 66.5428C285.609 66.2158 285.606 65.8873 285.599 65.5616Z"
          fill="#3B3B3C"
        />
        <path
          d="M138.827 148.251C138.089 147.219 138.323 145.783 139.351 145.041L203.564 99.3187L206.238 103.055L142.026 148.777C140.998 149.519 139.566 149.283 138.827 148.251Z"
          fill="#3B3B3C"
        />
        <mask id="mask0_6960_94997" maskUnits="userSpaceOnUse" x="0" y="0" width="239" height="258">
          <path d="M238.235 0.181885H0.130859V258H238.235V0.181885Z" fill="white" />
        </mask>
        <g mask="url(#mask0_6960_94997)">
          <path
            d="M67.0303 45.3586L53.2441 67.6876L70.4884 74.8087L84.2394 48.7874L67.0303 45.3586Z"
            fill="white"
          />
          <path
            d="M56.6703 62.4402C56.6141 62.4402 56.558 62.4247 56.5074 62.3937C56.3627 62.3035 56.3178 62.1117 56.4077 61.9651L65.3704 47.4579C65.4603 47.3127 65.6513 47.2676 65.7974 47.3578C65.9421 47.448 65.987 47.6398 65.8971 47.7864L56.9344 62.2936C56.8754 62.3881 56.7743 62.4402 56.6703 62.4402Z"
            fill="#3B3B3C"
          />
          <path
            d="M72.6167 70.2958C72.5661 70.2958 72.5142 70.2831 72.4664 70.2564C72.3161 70.1732 72.2628 69.9843 72.3456 69.8334L81.4193 53.4032C81.5022 53.2523 81.6904 53.1988 81.8407 53.2819C81.991 53.3651 82.0444 53.554 81.9615 53.7049L72.8878 70.1351C72.8316 70.238 72.7249 70.2958 72.6167 70.2958Z"
            fill="#3B3B3C"
          />
          <path
            d="M60.4945 35.6434C60.2065 30.8232 61.68 25.9184 64.5762 22.0568C65.8165 20.4031 67.3447 18.9129 69.2226 18.0515C71.1006 17.1901 73.3634 17.0265 75.2132 17.9444C75.2315 17.9542 75.2498 17.9627 75.268 17.9725C77.3131 19.0201 79.8007 18.8466 81.5129 17.3127C82.6183 16.3245 83.9063 15.5434 85.3053 15.0514C88.8406 13.8093 92.9758 14.4451 95.9746 16.6938C98.9734 18.9425 100.749 22.7364 100.552 26.4823C100.298 31.3491 97.0028 35.5405 93.2862 38.6859C89.5696 41.8312 85.2575 44.3097 80.5914 45.6942C76.8018 46.8192 72.7777 47.2097 68.8504 46.7121C67.0778 46.4879 65.7406 46.3441 64.4288 45.0865C63.27 43.9756 62.3879 42.5982 61.7572 41.1263C61.0142 39.3964 60.6082 37.5213 60.4959 35.6434H60.4945Z"
            fill="#3B3B3C"
          />
          <path
            d="M71.3948 51.9129C69.7683 52.646 67.7358 52.2428 66.4127 51.0459C65.0896 49.8489 64.4828 47.9541 64.7174 46.1833C64.8382 45.2796 65.1893 44.3646 65.8888 43.781C66.792 43.0281 68.1362 42.9717 69.2219 43.4186C70.3077 43.867 71.1645 44.7467 71.8373 45.7096C71.8373 45.7096 72.8486 44.7425 76.0131 41.8171C79.5949 38.5068 74.4035 32.8829 74.4035 32.8829C79.6749 35.2543 84.7862 35.36 89.7388 33.2298C92.4652 37.4071 93.5425 42.6305 92.6913 47.5466C92.1955 50.4114 91.0016 53.2522 88.8231 55.1753C86.3341 57.3704 82.7425 58.1204 79.4979 57.431C76.2533 56.7416 73.3753 54.7128 71.3386 52.0919L71.3934 51.9115L71.3948 51.9129Z"
            fill="white"
          />
          <path
            d="M81.8561 57.9893C81.0498 57.9893 80.2366 57.9061 79.4345 57.7355C76.2868 57.0672 73.3456 55.1541 71.1432 52.3443C69.5167 52.8955 67.5404 52.4839 66.2046 51.2756C64.8408 50.042 64.1525 48.0739 64.4096 46.141C64.5135 45.3557 64.8211 44.2659 65.6906 43.5413C66.6232 42.7631 68.0573 42.6009 69.3397 43.131C70.2569 43.5089 71.1109 44.218 71.882 45.2415C72.3526 44.796 73.524 43.6964 75.805 41.5887C76.534 40.9148 76.9231 40.0815 76.9625 39.113C77.0762 36.2722 74.208 33.1254 74.1785 33.0944C74.0788 32.9858 74.069 32.8223 74.1546 32.7025C74.2403 32.5826 74.3991 32.5389 74.5325 32.5995C79.686 34.9173 84.7622 35.0343 89.6193 32.9435C89.7555 32.8843 89.917 32.9323 89.9999 33.0592C92.7698 37.3042 93.8626 42.6037 92.9987 47.6002C92.597 49.9194 91.5829 53.1564 89.0293 55.4093C87.1402 57.0771 84.5318 57.9893 81.8561 57.9893ZM71.6826 52.0271C73.7895 54.6846 76.5818 56.4934 79.5638 57.1279C82.8351 57.8243 86.3058 56.9855 88.6206 54.9426C91.0379 52.8095 92.0043 49.715 92.3877 47.4945C93.2108 42.7363 92.2037 37.6947 89.6221 33.6174C85.0347 35.5221 80.2675 35.5306 75.4286 33.6485C76.3318 34.8623 77.6661 37.0292 77.5819 39.137C77.5369 40.2775 77.0804 41.2559 76.225 42.0454C73.0998 44.9342 72.0632 45.9253 72.0534 45.9352C71.9888 45.9972 71.9017 46.0282 71.809 46.0198C71.7191 46.0113 71.6376 45.9634 71.5857 45.8887C70.83 44.8073 69.9956 44.0728 69.1051 43.7062C68.032 43.2635 66.8465 43.3862 66.0881 44.0206C65.529 44.4859 65.1526 45.2683 65.0248 46.2242C64.7944 47.9569 65.4054 49.7164 66.6204 50.8146C67.8831 51.958 69.7948 52.2921 71.2682 51.6295C71.4241 51.559 71.6081 51.6295 71.677 51.786C71.7121 51.8664 71.7121 51.9524 71.6826 52.0285V52.0271Z"
            fill="#3B3B3C"
          />
          <path
            d="M71.5275 49.0736C71.4629 49.0736 71.3969 49.0538 71.3407 49.0101C70.467 48.3475 69.3841 47.9387 68.2913 47.8597C68.1213 47.847 67.9921 47.699 68.0048 47.527C68.0174 47.3564 68.1705 47.2267 68.3363 47.2394C69.547 47.3268 70.7465 47.7808 71.7143 48.5139C71.8505 48.6168 71.8772 48.8128 71.7747 48.9495C71.7143 49.0299 71.6216 49.0736 71.5275 49.0736Z"
            fill="#3B3B3C"
          />
          <path
            d="M90.4864 33.1692C90.3852 33.1692 90.2869 33.1199 90.2265 33.0282C90.1324 32.8844 90.1731 32.6913 90.3164 32.5982C92.1789 31.3731 93.5371 29.4233 94.0428 27.2493C94.0821 27.083 94.2451 26.9786 94.415 27.0181C94.5807 27.0576 94.6847 27.224 94.6454 27.3917C94.1046 29.7194 92.6508 31.8059 90.6549 33.1185C90.6029 33.1537 90.5439 33.1692 90.4849 33.1692H90.4864Z"
            fill="#3B3B3C"
          />
          <path
            d="M14.4986 159.505C14.4986 159.505 -14.4825 280.729 -67.5144 334.568C-72.0527 339.175 -74.175 345.632 -73.2044 352.03C-70.4093 370.455 -60.8482 407.475 -28.3809 427.867C-24.7922 430.121 -20.1823 427.251 -20.6177 423.031L-23.8062 392.099C-23.8062 392.099 -3.62492 369.545 8.05711 357.305C8.05711 357.305 7.96864 396.404 8.95887 419.002C9.29317 426.645 15.5703 432.672 23.2113 432.672H93.1293C96.4428 432.672 98.2533 428.803 96.1338 426.254L77.8586 404.273C77.8586 404.273 82.0822 235.696 89.5504 159.505H14.4972H14.4986Z"
            fill="white"
          />
          <path
            d="M93.1303 432.982H23.2123C15.3901 432.982 8.99355 426.848 8.65083 419.016C7.74767 398.42 7.74345 363.702 7.74767 358.08C-3.46243 369.865 -22.0101 390.56 -23.4835 392.205L-20.3092 423C-20.0956 425.067 -21.0578 427.035 -22.8178 428.136C-24.5862 429.243 -26.7801 429.24 -28.5457 428.132C-42.7841 419.189 -54.1066 406.14 -62.1998 389.347C-69.0262 375.184 -72.1191 361.262 -73.5125 352.078C-74.4887 345.641 -72.3298 339.013 -67.7368 334.351C-40.3822 306.58 -19.5633 260.507 -6.91492 226.747C6.79536 190.152 14.1231 159.737 14.1962 159.434C14.2355 159.266 14.4041 159.163 14.5698 159.204C14.7355 159.244 14.8381 159.412 14.7987 159.579C14.7257 159.882 7.39091 190.328 -6.33201 226.958C-14.3916 248.475 -23.0467 267.886 -32.0558 284.651C-43.3221 305.619 -55.1783 322.489 -67.2957 334.789C-71.7511 339.312 -73.8468 345.741 -72.9001 351.985C-69.9223 371.616 -60.1576 407.544 -28.2184 427.606C-26.6551 428.587 -24.7112 428.59 -23.1464 427.61C-21.5649 426.622 -20.7361 424.923 -20.9272 423.066L-24.1156 392.135C-24.124 392.047 -24.0959 391.96 -24.0384 391.895C-23.8361 391.669 -3.72086 369.197 7.83195 357.093C7.91903 357.001 8.05387 356.972 8.17185 357.02C8.28984 357.068 8.36569 357.182 8.36569 357.309C8.36569 357.699 8.28703 396.659 9.26603 418.992C9.59471 426.491 15.7188 432.364 23.2081 432.364H93.1261C94.5405 432.364 95.7892 431.568 96.3876 430.285C96.9831 429.007 96.7935 427.54 95.8917 426.457L77.6165 404.476C77.5688 404.418 77.5421 404.345 77.5449 404.269C77.5898 402.566 82.0663 233.099 89.4517 157.768C89.4685 157.597 89.6174 157.473 89.7902 157.488C89.9601 157.505 90.0851 157.658 90.0683 157.828C82.7672 232.306 78.309 398.85 78.1685 404.168L96.3693 426.058C97.4256 427.328 97.6489 429.05 96.9508 430.548C96.2499 432.053 94.7849 432.986 93.1275 432.986L93.1303 432.982Z"
            fill="#3B3B3C"
          />
          <path
            d="M8.05811 357.615C7.98648 357.615 7.91344 357.589 7.85585 357.539C7.72663 357.426 7.71259 357.23 7.82495 357.1C39.2865 320.724 53.9238 277.229 60.6617 247.147C67.9656 214.542 67.8223 190.231 67.8195 189.989C67.8195 189.885 67.8701 189.786 67.9571 189.729L77.1011 183.594C77.2443 183.499 77.4354 183.538 77.5309 183.68C77.6264 183.823 77.5871 184.016 77.4452 184.112L68.4389 190.153C68.4389 192.372 68.2648 216.024 61.2685 247.267C56.9704 266.455 50.9784 284.714 43.4582 301.536C34.0558 322.566 22.2235 341.399 8.28988 357.508C8.22948 357.578 8.14239 357.615 8.05671 357.615H8.05811Z"
            fill="#3B3B3C"
          />
          <path
            d="M8.89203 159.574L84.1812 158.268L88.6015 120.43L95.2621 111.476C95.2621 111.476 76.6175 55.3431 52.405 62.1724C26.6925 69.4246 8.89062 159.574 8.89062 159.574H8.89203Z"
            fill="#FC8543"
          />
          <path
            d="M62.0414 132.447C62.0414 132.447 76.7125 150.772 82.9573 156.434C93.7909 166.256 109.899 167.793 122.575 160.228L164.965 134.93C166.611 133.947 168.639 133.817 170.367 134.621C173.96 136.293 180.321 138.25 182.817 132.73C182.817 132.73 188.146 131.741 187.836 127.776C187.836 127.776 192.755 126.485 192.434 122.792C192.434 122.792 195.256 122.315 195.106 119.368C194.956 116.42 184.462 99.5668 162.633 104.996C151.103 107.864 137.253 113.607 126.056 118.828C100.353 130.812 99.4445 117.905 94.7742 111.373C94.7742 111.373 78.7449 115.178 62.04 132.448L62.0414 132.447Z"
            fill="white"
          />
          <path
            d="M105.165 165.399C100.579 165.399 96.0271 164.446 91.8077 162.517C84.0979 158.996 82.0261 158.048 61.7999 132.642C61.6932 132.508 61.7156 132.312 61.8491 132.205C61.9825 132.097 62.1777 132.12 62.2845 132.254C82.4194 157.545 84.4631 158.478 92.0647 161.952C101.647 166.33 112.993 165.585 122.418 159.961L164.807 134.663C166.559 133.617 168.687 133.496 170.497 134.339C173.031 135.518 176.636 136.705 179.421 135.666C180.8 135.153 181.848 134.121 182.535 132.601C182.577 132.508 182.661 132.441 182.761 132.423C182.812 132.413 187.812 131.436 187.527 127.799C187.516 127.649 187.612 127.513 187.757 127.473C187.803 127.46 192.42 126.203 192.127 122.818C192.113 122.656 192.225 122.512 192.384 122.484C192.486 122.465 194.93 122.009 194.797 119.381C194.731 118.074 192.338 113.129 187.082 109.214C182.581 105.862 174.825 102.461 163.434 105.294C150.725 108.454 136.11 113.874 126.199 119.099C116.822 124.043 109.834 125.545 104.835 123.686C100.484 122.069 98.3756 118.243 96.5173 114.866C95.8459 113.648 95.2125 112.496 94.5242 111.55C94.4231 111.412 94.454 111.218 94.5916 111.116C94.7293 111.015 94.9231 111.046 95.0242 111.184C95.7364 112.161 96.3783 113.33 97.0595 114.565C100.71 121.194 105.253 129.441 125.911 118.547C135.861 113.3 150.531 107.861 163.285 104.689C174.909 101.799 182.842 105.282 187.45 108.714C192.588 112.54 195.325 117.593 195.415 119.347C195.548 121.964 193.509 122.805 192.757 123.027C192.836 126.251 189.15 127.673 188.156 127.998C188.24 131.591 183.924 132.787 183.032 132.995C182.274 134.594 181.132 135.687 179.636 136.244C176.65 137.358 172.875 136.125 170.235 134.897C168.61 134.142 166.698 134.252 165.122 135.192L122.733 160.49C117.28 163.744 111.194 165.394 105.164 165.394L105.165 165.399Z"
            fill="#3B3B3C"
          />
          <path
            d="M182.482 132.042C182.355 132.042 182.237 131.965 182.191 131.839C181.362 129.574 179.766 127.645 177.698 126.41C177.55 126.323 177.502 126.131 177.589 125.984C177.676 125.838 177.866 125.788 178.014 125.876C180.205 127.184 181.894 129.226 182.771 131.625C182.83 131.786 182.747 131.965 182.587 132.024C182.552 132.037 182.515 132.044 182.48 132.044L182.482 132.042Z"
            fill="#3B3B3C"
          />
          <path
            d="M187.482 127.308C187.35 127.308 187.227 127.222 187.185 127.09C186.264 124.088 184.226 121.39 181.592 119.685C181.449 119.592 181.407 119.399 181.499 119.255C181.592 119.111 181.783 119.071 181.928 119.162C184.681 120.944 186.813 123.767 187.777 126.906C187.827 127.07 187.734 127.245 187.572 127.296C187.541 127.305 187.511 127.31 187.48 127.31L187.482 127.308Z"
            fill="#3B3B3C"
          />
          <path
            d="M192.334 122.185C192.206 122.185 192.087 122.105 192.042 121.978C191.09 119.255 189.291 116.812 186.976 115.096C186.838 114.995 186.809 114.8 186.91 114.662C187.011 114.524 187.205 114.494 187.342 114.596C189.755 116.385 191.632 118.934 192.625 121.772C192.681 121.934 192.597 122.112 192.435 122.168C192.402 122.181 192.367 122.185 192.333 122.185H192.334Z"
            fill="#3B3B3C"
          />
          <path
            d="M59.7794 133.77C59.6656 133.77 59.5575 133.708 59.5027 133.599C54.3436 123.402 45.8655 104.585 45.7812 104.396C45.711 104.239 45.7812 104.054 45.9357 103.984C46.0916 103.913 46.2756 103.984 46.3458 104.139C46.4301 104.328 54.9026 123.132 60.0547 133.317C60.132 133.471 60.0716 133.657 59.9185 133.734C59.8735 133.757 59.8258 133.768 59.778 133.768L59.7794 133.77Z"
            fill="#3B3B3C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6960_94997">
          <rect width="385" height="258" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  noExternalData: (
    <svg
      width="444"
      height="297"
      viewBox="0 0 444 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_825_7607)">
        <path
          d="M106.511 213.762C106.511 219.915 111.313 224.902 117.236 224.902H432.78C438.703 224.902 443.504 219.915 443.504 213.762V209.679H106.509V213.762H106.511Z"
          fill="white"
        />
        <path
          d="M336.521 224.902V247.959C336.521 253.903 331.709 258.722 325.773 258.722H224.24C218.305 258.722 213.493 253.903 213.493 247.959V224.902H336.519H336.521Z"
          fill="white"
        />
        <path
          d="M325.775 259.079H224.242C218.119 259.079 213.138 254.091 213.138 247.959V224.902C213.138 224.704 213.298 224.544 213.495 224.544C213.692 224.544 213.852 224.704 213.852 224.902V247.959C213.852 253.696 218.513 258.364 224.242 258.364H325.775C331.504 258.364 336.165 253.696 336.165 247.959V224.902C336.165 224.704 336.325 224.544 336.522 224.544C336.719 224.544 336.879 224.704 336.879 224.902V247.959C336.879 254.091 331.898 259.079 325.775 259.079Z"
          fill="#080808"
        />
        <path
          d="M331.938 233.202H218.079C217.882 233.202 217.722 233.042 217.722 232.845C217.722 232.648 217.882 232.488 218.079 232.488H331.938C332.135 232.488 332.295 232.648 332.295 232.845C332.295 233.042 332.135 233.202 331.938 233.202Z"
          fill="#080808"
        />
        <path
          d="M119.19 0.918549H430.825C437.824 0.918549 443.506 6.60886 443.506 13.6174V209.679H106.511V13.6158C106.511 6.60725 112.193 0.916931 119.191 0.916931L119.19 0.918549Z"
          fill="white"
        />
        <path
          d="M443.506 210.037H106.511C106.314 210.037 106.154 209.877 106.154 209.679V13.6158C106.154 6.41637 112.002 0.559448 119.19 0.559448H430.825C438.014 0.559448 443.863 6.41637 443.863 13.6158V209.678C443.863 209.875 443.703 210.035 443.506 210.035V210.037ZM106.868 209.322H443.149V13.6158C443.149 6.81103 437.62 1.27438 430.825 1.27438H119.19C112.395 1.27438 106.866 6.81103 106.866 13.6158V209.322H106.868Z"
          fill="#080808"
        />
        <path
          d="M431.995 198.082H118.021C117.823 198.082 117.664 197.922 117.664 197.725V14.1431C117.664 13.2454 118.392 12.5159 119.288 12.5159H430.725C431.622 12.5159 432.35 13.2454 432.35 14.1431V197.725C432.35 197.922 432.19 198.082 431.993 198.082H431.995ZM118.377 197.367H431.638V14.1431C431.638 13.6401 431.229 13.2309 430.725 13.2309H119.29C118.788 13.2309 118.377 13.6401 118.377 14.1431V197.367Z"
          fill="#080808"
        />
        <path
          d="M432.78 225.259H117.235C111.125 225.259 106.154 220.101 106.154 213.762C106.154 213.565 106.314 213.404 106.511 213.404C106.708 213.404 106.868 213.565 106.868 213.762C106.868 219.708 111.519 224.544 117.235 224.544H432.78C438.497 224.544 443.149 219.708 443.149 213.762C443.149 213.565 443.309 213.404 443.506 213.404C443.703 213.404 443.863 213.565 443.863 213.762C443.863 220.101 438.891 225.259 432.781 225.259H432.78Z"
          fill="#080808"
        />
        <path
          d="M315.245 77.733C329.19 77.733 340.494 66.4011 340.494 52.4225C340.494 38.444 329.19 27.1121 315.245 27.1121C301.301 27.1121 289.997 38.444 289.997 52.4225C289.997 66.4011 301.301 77.733 315.245 77.733Z"
          fill="#FFDBC6"
        />
        <mask
          id="mask0_825_7607"
          // style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="293"
          y="30"
          width="45"
          height="45">
          <path
            d="M315.246 74.5902C327.458 74.5902 337.359 64.6654 337.359 52.4225C337.359 40.1797 327.458 30.2549 315.246 30.2549C303.033 30.2549 293.132 40.1797 293.132 52.4225C293.132 64.6654 303.033 74.5902 315.246 74.5902Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_825_7607)">
          <path
            d="M329.068 76.7479H301.421C301.324 76.7479 301.231 76.7075 301.163 76.6363C301.095 76.5652 301.06 76.4697 301.064 76.3727L302.441 48.8172C302.878 40.0439 308.502 33.1729 315.244 33.1729C321.986 33.1729 327.61 40.0455 328.047 48.8188L329.424 76.3743C329.428 76.4713 329.393 76.5668 329.325 76.6379C329.257 76.7091 329.163 76.7495 329.067 76.7495L329.068 76.7479ZM301.796 76.033H328.693L327.337 48.8528C326.918 40.4612 321.606 33.8862 315.246 33.8862C308.885 33.8862 303.573 40.4596 303.154 48.8528L301.798 76.033H301.796Z"
            fill="white"
          />
          <path
            d="M327.752 63.1141L315.244 60.2269L302.736 63.1141C299.372 63.8905 296.692 66.4332 295.733 69.7572L293.018 84.1318H337.469L334.754 69.7572C333.794 66.4332 331.115 63.8905 327.75 63.1141H327.752Z"
            fill="white"
          />
          <path
            d="M315.246 67.9892C312.267 67.9892 309.853 65.5695 309.853 62.5836L311.586 52.4646H318.906L320.639 62.5836C320.639 65.5695 318.224 67.9892 315.246 67.9892Z"
            fill="white"
          />
          <path
            d="M324.277 45.4496C323.885 45.3525 323.487 45.3897 323.118 45.5304C322.804 40.5276 319.401 37.1357 315.244 37.1357C311.086 37.1357 307.683 40.5276 307.37 45.5304C307 45.3881 306.602 45.3509 306.21 45.4496C305.044 45.7407 304.375 47.0929 304.718 48.4726C305.06 49.8507 306.283 50.7339 307.449 50.4427C307.638 50.3958 307.811 50.3182 307.971 50.2211C309.172 53.9155 311.976 56.7445 315.244 56.7445C318.511 56.7445 321.315 53.9155 322.517 50.2211C322.677 50.3182 322.849 50.3958 323.038 50.4427C324.205 50.7339 325.427 49.8507 325.77 48.4726C326.112 47.0945 325.443 45.7407 324.277 45.4496Z"
            fill="white"
          />
          <path
            d="M315.244 57.1019C312.112 57.1019 309.146 54.5528 307.764 50.7193C307.688 50.7468 307.612 50.7711 307.535 50.7905C306.866 50.9571 306.168 50.8099 305.566 50.3748C304.981 49.9526 304.558 49.3089 304.372 48.56C303.983 46.9926 304.769 45.4415 306.126 45.1034C306.427 45.029 306.74 45.0193 307.05 45.0727C307.533 40.2412 310.922 36.7782 315.244 36.7782C319.566 36.7782 322.956 40.2396 323.437 45.0727C323.749 45.0177 324.063 45.0274 324.363 45.1034C325.718 45.4415 326.505 46.9926 326.115 48.56C325.93 49.3089 325.507 49.9542 324.922 50.3748C324.319 50.8099 323.618 50.9555 322.953 50.7905C322.875 50.7711 322.799 50.7468 322.724 50.7193C321.343 54.5544 318.376 57.1019 315.244 57.1019ZM307.971 49.8637C308.013 49.8637 308.055 49.8717 308.095 49.8863C308.197 49.9235 308.278 50.006 308.311 50.1111C309.533 53.8653 312.319 56.387 315.245 56.387C318.172 56.387 320.958 53.8653 322.179 50.1111C322.213 50.0076 322.292 49.9251 322.396 49.8863C322.497 49.8475 322.612 49.8588 322.706 49.917C322.843 50.0011 322.985 50.061 323.127 50.0966C323.588 50.2114 324.079 50.1047 324.508 49.7941C324.956 49.4706 325.282 48.9708 325.427 48.3869C325.721 47.2013 325.169 46.0399 324.195 45.7973C323.891 45.7213 323.563 45.7455 323.249 45.8652C323.144 45.9057 323.024 45.8944 322.929 45.8329C322.833 45.7714 322.772 45.6679 322.766 45.5547C322.473 40.885 319.311 37.4947 315.249 37.4947C311.186 37.4947 308.024 40.885 307.732 45.5547C307.725 45.6679 307.664 45.7714 307.568 45.8329C307.473 45.8944 307.354 45.9073 307.249 45.8652C306.935 45.7439 306.607 45.7213 306.304 45.7973C305.33 46.0399 304.777 47.2013 305.071 48.3869C305.217 48.9724 305.543 49.4722 305.99 49.7941C306.42 50.1047 306.909 50.2114 307.37 50.0966C307.514 50.061 307.652 50.0028 307.791 49.917C307.848 49.8831 307.913 49.8653 307.977 49.8653L307.971 49.8637Z"
            fill="#FFDBC6"
          />
          <path
            d="M307.239 46.7872C311.177 46.0448 315.281 42.5284 317.744 39.3613C318.226 42.1742 320.71 45.4593 323.313 46.6142C323.313 46.6142 324.554 35.4179 315.244 35.7786C305.934 36.1393 307.239 46.7872 307.239 46.7872Z"
            fill="#FFDBC6"
          />
        </g>
        <path
          d="M158.317 77.851C172.258 77.851 183.559 66.5213 183.559 52.5454C183.559 38.5696 172.258 27.2399 158.317 27.2399C144.376 27.2399 133.075 38.5696 133.075 52.5454C133.075 66.5213 144.376 77.851 158.317 77.851Z"
          fill="#FFDBC6"
        />
        <mask
          id="mask1_825_7607"
          // style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="136"
          y="30"
          width="45"
          height="45">
          <path
            d="M158.317 74.7082C170.527 74.7082 180.425 64.7856 180.425 52.5454C180.425 40.3053 170.527 30.3826 158.317 30.3826C146.107 30.3826 136.208 40.3053 136.208 52.5454C136.208 64.7856 146.107 74.7082 158.317 74.7082Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_825_7607)">
          <path
            d="M170.823 63.2354L158.319 60.3482L145.814 63.2354C142.451 64.0118 139.772 66.5545 138.812 69.8768L136.099 84.2482H180.54L177.826 69.8768C176.867 66.5529 174.188 64.0118 170.825 63.2354H170.823Z"
            fill="white"
          />
          <path
            d="M152.925 52.5859H163.708V63.0656C163.708 65.8476 161.452 68.1073 158.674 68.1073H157.96C155.182 68.1073 152.925 65.8476 152.925 63.0656V52.5859Z"
            fill="white"
          />
          <path
            d="M167.261 45.7407C166.874 45.6436 166.48 45.6808 166.113 45.8215C165.803 40.8688 162.432 37.5093 158.317 37.5093C154.201 37.5093 150.83 40.8688 150.52 45.8215C150.155 45.6808 149.761 45.6436 149.372 45.7407C148.217 46.0286 147.555 47.3679 147.894 48.7346C148.233 50.1014 149.443 50.9732 150.598 50.6853C150.784 50.6384 150.956 50.5624 151.115 50.4653C152.305 54.1241 155.081 56.924 158.317 56.924C161.552 56.924 164.328 54.1241 165.519 50.4653C165.677 50.5624 165.848 50.6384 166.036 50.6853C167.19 50.9732 168.402 50.0998 168.739 48.7346C169.077 47.3695 168.416 46.0286 167.261 45.7407Z"
            fill="white"
          />
          <path
            d="M158.317 57.2814C155.112 57.2814 152.081 54.5867 150.776 50.5753C150.714 50.3877 150.818 50.1855 151.005 50.1256C151.191 50.0642 151.394 50.1677 151.454 50.3553C152.664 54.0707 155.421 56.5681 158.317 56.5681C161.213 56.5681 163.97 54.0723 165.18 50.3553C165.241 50.1677 165.443 50.0658 165.629 50.1256C165.816 50.1871 165.918 50.3893 165.858 50.5753C164.553 54.5867 161.523 57.2814 158.317 57.2814Z"
            fill="#FFDBC6"
          />
          <path
            d="M160.959 33.7082C154.277 32.584 146.51 33.9783 149.794 44.5324L150.646 47.0637L152.011 47.9906C152.011 47.9906 151.627 41.0321 153.802 40.6714C155.858 40.3285 155.989 41.6969 158.457 41.6338C160.925 41.6969 161.056 40.3302 163.112 40.6714C165.286 41.0338 164.903 47.9906 164.903 47.9906L166.268 47.0637L167.121 44.5324C169.292 36.3317 165.813 33.1 160.961 33.7082H160.959Z"
            fill="#FFDBC6"
          />
          <path
            d="M152.011 48.3497C151.942 48.3497 151.871 48.3286 151.811 48.2882L150.446 47.3614C150.381 47.3177 150.333 47.2546 150.309 47.1802L149.456 44.6489C148.193 40.5922 148.434 37.5303 150.17 35.5408C152.804 32.5161 158.044 32.8639 160.969 33.3507C163.342 33.066 165.341 33.6985 166.594 35.1348C167.778 36.4935 168.891 39.2416 167.467 44.6278L166.607 47.1818C166.583 47.2562 166.535 47.3193 166.47 47.363L165.105 48.2898C164.992 48.3658 164.847 48.3723 164.729 48.306C164.611 48.2397 164.542 48.1103 164.548 47.976C164.689 45.4091 164.408 41.2538 163.054 41.0289C162.124 40.8736 161.659 41.1001 161.069 41.388C160.45 41.6889 159.746 42.0253 158.448 41.9962C157.155 42.0285 156.463 41.6889 155.846 41.388C155.256 41.1017 154.792 40.8736 153.861 41.0289C152.507 41.2538 152.226 45.4091 152.366 47.976C152.375 48.1119 152.303 48.2397 152.186 48.306C152.131 48.3367 152.071 48.3529 152.01 48.3529L152.011 48.3497ZM162.494 40.2606C162.699 40.2606 162.923 40.2784 163.17 40.3205C165.218 40.6618 165.325 45.401 165.285 47.3015L165.968 46.8373L166.782 44.4192C167.84 40.4191 167.591 37.3621 166.055 35.6023C164.937 34.3212 163.191 33.7891 161.003 34.064C160.969 34.0689 160.933 34.0673 160.899 34.0624C158.133 33.5966 153.127 33.231 150.706 36.0099C149.146 37.8004 148.952 40.6326 150.134 44.4289L150.947 46.8389L151.63 47.3032C151.59 45.4026 151.696 40.6634 153.744 40.3221C154.902 40.1296 155.54 40.4418 156.159 40.7426C156.729 41.0208 157.311 41.3087 158.449 41.2796C159.588 41.3087 160.187 41.0208 160.757 40.7426C161.243 40.5065 161.743 40.2622 162.495 40.2622L162.494 40.2606Z"
            fill="white"
          />
        </g>
        <path
          d="M158.196 163.481C172.07 163.481 183.317 152.206 183.317 138.298C183.317 124.39 172.07 113.115 158.196 113.115C144.322 113.115 133.075 124.39 133.075 138.298C133.075 152.206 144.322 163.481 158.196 163.481Z"
          fill="#FFDBC6"
        />
        <mask
          id="mask2_825_7607"
          // style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="136"
          y="116"
          width="45"
          height="45">
          <path
            d="M158.196 160.354C170.347 160.354 180.197 150.479 180.197 138.298C180.197 126.117 170.347 116.242 158.196 116.242C146.044 116.242 136.194 126.117 136.194 138.298C136.194 150.479 146.044 160.354 158.196 160.354Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_825_7607)">
          <path
            d="M170.639 148.935L158.194 146.062L145.749 148.935C142.402 149.708 139.736 152.238 138.781 155.544L136.081 169.846H180.305L177.605 155.544C176.65 152.236 173.984 149.706 170.637 148.935H170.639Z"
            fill="white"
          />
          <path
            d="M152.83 138.339H163.561V148.768C163.561 151.537 161.316 153.786 158.551 153.786H157.84C155.075 153.786 152.83 151.537 152.83 148.768V138.339Z"
            fill="white"
          />
          <path
            d="M167.095 131.526C166.709 131.429 166.316 131.466 165.953 131.607C165.644 126.677 162.29 123.335 158.195 123.335C154.101 123.335 150.746 126.678 150.438 131.607C150.074 131.468 149.682 131.43 149.296 131.526C148.146 131.812 147.487 133.146 147.824 134.505C148.162 135.864 149.367 136.732 150.515 136.446C150.701 136.399 150.87 136.325 151.029 136.228C152.213 139.869 154.976 142.656 158.195 142.656C161.414 142.656 164.178 139.869 165.362 136.228C165.52 136.325 165.69 136.399 165.875 136.446C167.025 136.732 168.23 135.864 168.566 134.505C168.904 133.146 168.245 131.812 167.095 131.526Z"
            fill="white"
          />
          <path
            d="M151.029 136.226C152.213 139.867 154.976 142.654 158.195 142.654C161.414 142.654 164.178 139.867 165.362 136.226H151.029Z"
            fill="white"
          />
          <path
            d="M158.195 143.011C155.005 143.011 151.988 140.33 150.69 136.338C150.628 136.15 150.732 135.948 150.919 135.888C151.106 135.828 151.308 135.929 151.368 136.118C152.571 139.815 155.315 142.298 158.195 142.298C161.075 142.298 163.821 139.814 165.023 136.118C165.084 135.93 165.284 135.828 165.472 135.888C165.659 135.95 165.761 136.15 165.701 136.338C164.402 140.33 161.385 143.011 158.195 143.011Z"
            fill="#FFDBC6"
          />
          <path
            d="M163.554 121.332C157.402 117.541 146.445 119.822 149.712 130.324L150.562 132.842L151.476 133.496L152.944 126.366C152.944 126.366 154.243 127.045 156.782 127.102C159.239 127.165 163.441 126.196 163.441 126.196L165.247 133.156L166.106 132.842L166.954 130.324C167.899 126.934 168.382 120.727 163.554 121.332Z"
            fill="#FFDBC6"
          />
          <path
            d="M151.475 133.853C151.402 133.853 151.33 133.831 151.268 133.787L150.354 133.134C150.293 133.09 150.247 133.028 150.223 132.957L149.375 130.439C148.115 126.392 148.831 123.073 151.386 121.083C154.442 118.706 159.798 118.659 163.635 120.964C164.994 120.823 166.053 121.185 166.792 122.042C168.376 123.883 168.055 127.707 167.299 130.421L166.444 132.959C166.41 133.062 166.33 133.143 166.228 133.18L165.369 133.494C165.275 133.528 165.17 133.522 165.081 133.475C164.992 133.428 164.928 133.345 164.902 133.248L163.182 126.623C162.124 126.853 158.874 127.516 156.771 127.463C154.986 127.422 153.793 127.084 153.205 126.867L151.825 133.572C151.801 133.69 151.719 133.789 151.606 133.832C151.564 133.848 151.52 133.857 151.475 133.857V133.853ZM150.861 132.619L151.236 132.886L152.593 126.295C152.615 126.185 152.688 126.093 152.79 126.044C152.891 125.996 153.008 125.999 153.108 126.051C153.119 126.057 154.379 126.693 156.789 126.746C159.178 126.816 163.319 125.86 163.361 125.85C163.551 125.806 163.737 125.921 163.786 126.109L165.493 132.689L165.822 132.569L166.615 130.212C167.375 127.485 167.56 124.034 166.25 122.511C165.646 121.811 164.781 121.541 163.598 121.69C163.518 121.699 163.435 121.682 163.367 121.64C159.759 119.416 154.687 119.422 151.824 121.651C150.194 122.919 148.564 125.436 150.054 130.22L150.863 132.622L150.861 132.619Z"
            fill="white"
          />
        </g>
        <path
          d="M315.244 163.604C329.187 163.604 340.49 152.273 340.49 138.295C340.49 124.317 329.187 112.986 315.244 112.986C301.3 112.986 289.997 124.317 289.997 138.295C289.997 152.273 301.3 163.604 315.244 163.604Z"
          fill="#FFDBC6"
        />
        <mask
          id="mask3_825_7607"
          // style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="293"
          y="116"
          width="45"
          height="45">
          <path
            d="M315.244 160.463C327.456 160.463 337.357 150.538 337.357 138.295C337.357 126.052 327.456 116.127 315.244 116.127C303.031 116.127 293.13 126.052 293.13 138.295C293.13 150.538 303.031 160.463 315.244 160.463Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_825_7607)">
          <path
            d="M319.191 146.583C316.909 146.583 315.053 144.723 315.053 142.434C315.053 141.538 314.263 141.441 313.923 141.441C313.123 141.441 312.267 141.944 312.267 142.693C312.267 144.7 310.639 146.332 308.636 146.332C306.633 146.332 305.005 144.7 305.005 142.693C305.005 142.612 305.009 142.53 305.013 142.447C304.792 142.487 304.569 142.508 304.345 142.508C302.281 142.508 300.601 140.825 300.601 138.756C300.601 138.326 300.675 137.903 300.819 137.498C299.423 136.577 298.569 135.005 298.569 133.323C298.569 131.252 299.838 129.423 301.722 128.679C301.003 127.898 300.601 126.875 300.601 125.797C300.601 123.446 302.508 121.535 304.852 121.535C305.488 121.535 306.112 121.677 306.682 121.952C307.1 120.03 308.83 118.592 310.834 118.592C311.766 118.592 312.655 118.893 313.39 119.45C314.134 117.648 315.914 116.43 317.889 116.43C320.576 116.43 322.762 118.62 322.762 121.313C322.762 121.337 322.762 121.361 322.762 121.384C323.035 121.332 323.312 121.306 323.591 121.306C326.059 121.306 328.068 123.32 328.068 125.795C328.068 126.384 327.952 126.969 327.727 127.511C330.142 127.969 331.908 130.067 331.908 132.584C331.908 135.371 329.695 137.65 326.938 137.747C326.873 139.791 325.261 141.452 323.241 141.588C323.299 141.866 323.328 142.148 323.328 142.428C323.328 144.715 321.47 146.576 319.19 146.576L319.191 146.583ZM313.923 140.728C314.418 140.728 314.855 140.867 315.181 141.129C315.564 141.436 315.766 141.887 315.766 142.436C315.766 144.328 317.302 145.87 319.191 145.87C321.081 145.87 322.617 144.33 322.617 142.436C322.617 142.07 322.557 141.705 322.439 141.35C322.402 141.239 322.423 141.114 322.494 141.02C322.565 140.927 322.672 140.87 322.796 140.88L322.864 140.885C322.9 140.888 322.937 140.889 322.972 140.889C324.767 140.889 326.229 139.426 326.229 137.625C326.229 137.569 326.224 137.512 326.221 137.455L326.217 137.413C326.211 137.311 326.248 137.213 326.317 137.14C326.388 137.067 326.49 137.024 326.587 137.032L326.67 137.037C326.697 137.038 326.726 137.041 326.755 137.041C329.204 137.041 331.195 135.044 331.195 132.588C331.195 130.272 329.462 128.367 327.164 128.157C327.044 128.145 326.938 128.074 326.881 127.967C326.825 127.861 326.826 127.733 326.884 127.626C327.194 127.068 327.358 126.436 327.358 125.797C327.358 123.717 325.67 122.023 323.594 122.023C323.215 122.023 322.84 122.08 322.48 122.191C322.365 122.227 322.239 122.203 322.147 122.125C322.053 122.047 322.007 121.929 322.021 121.808C322.044 121.62 322.053 121.463 322.053 121.313C322.053 119.014 320.188 117.143 317.894 117.143C316.053 117.143 314.41 118.384 313.9 120.158C313.866 120.279 313.769 120.373 313.648 120.406C313.525 120.438 313.396 120.404 313.307 120.317C312.642 119.665 311.765 119.307 310.838 119.307C309.019 119.307 307.472 120.731 307.315 122.545C307.304 122.67 307.229 122.78 307.116 122.835C307.003 122.89 306.871 122.882 306.766 122.814C306.192 122.444 305.532 122.248 304.853 122.248C302.902 122.248 301.315 123.839 301.315 125.795C301.315 126.869 301.794 127.875 302.631 128.553C302.736 128.639 302.784 128.774 302.755 128.907C302.726 129.04 302.626 129.143 302.495 129.177C300.604 129.662 299.284 131.366 299.284 133.321C299.284 134.853 300.111 136.276 301.442 137.04C301.602 137.132 301.665 137.329 301.589 137.498C301.408 137.897 301.316 138.319 301.316 138.753C301.316 140.428 302.675 141.79 304.346 141.79C304.677 141.79 305.009 141.734 305.33 141.624C305.451 141.582 305.588 141.609 305.684 141.697C305.781 141.784 305.823 141.915 305.793 142.041C305.743 142.259 305.719 142.478 305.719 142.69C305.719 144.302 307.027 145.614 308.636 145.614C310.245 145.614 311.553 144.302 311.553 142.69C311.553 141.475 312.782 140.723 313.923 140.723V140.728Z"
            fill="white"
          />
          <path
            d="M327.75 148.987L315.244 146.099L302.737 148.987C299.373 149.763 296.693 152.306 295.734 155.63L293.021 170.003H337.468L334.755 155.63C333.795 152.306 331.116 149.763 327.751 148.987H327.75Z"
            fill="white"
          />
          <path
            d="M315.244 153.862C312.265 153.862 309.851 151.442 309.851 148.456L311.584 138.337H318.904L320.637 148.456C320.637 151.442 318.222 153.862 315.244 153.862Z"
            fill="white"
          />
          <path
            d="M324.275 131.324C323.883 131.227 323.486 131.264 323.116 131.404C322.802 126.402 319.399 123.01 315.243 123.01C311.088 123.01 307.683 126.402 307.371 131.404C307.001 131.262 306.604 131.225 306.211 131.324C305.045 131.615 304.377 132.967 304.719 134.347C305.061 135.725 306.284 136.608 307.45 136.317C307.639 136.27 307.812 136.192 307.972 136.095C309.174 139.79 311.978 142.618 315.245 142.618C318.513 142.618 321.317 139.791 322.518 136.095C322.678 136.192 322.851 136.27 323.04 136.317C324.206 136.608 325.429 135.725 325.771 134.347C326.114 132.969 325.445 131.615 324.279 131.324H324.275Z"
            fill="white"
          />
          <path
            d="M315.244 142.974C312.112 142.974 309.146 140.425 307.764 136.592C307.688 136.619 307.612 136.644 307.535 136.663C306.867 136.83 306.168 136.682 305.566 136.247C304.981 135.825 304.558 135.181 304.372 134.432C303.983 132.865 304.769 131.314 306.125 130.976C306.425 130.901 306.738 130.892 307.048 130.945C307.531 126.112 310.918 122.651 315.242 122.651C319.566 122.651 322.953 126.112 323.436 130.945C323.746 130.89 324.059 130.9 324.36 130.976C325.715 131.314 326.501 132.863 326.114 134.432C325.928 135.181 325.503 135.827 324.92 136.247C324.318 136.682 323.617 136.828 322.951 136.663C322.874 136.644 322.798 136.619 322.722 136.592C321.341 140.427 318.374 142.974 315.242 142.974H315.244ZM307.971 135.738C308.013 135.738 308.055 135.746 308.095 135.76C308.197 135.799 308.278 135.882 308.311 135.985C309.533 139.739 312.319 142.261 315.245 142.261C318.172 142.261 320.958 139.739 322.179 135.985C322.213 135.882 322.292 135.799 322.396 135.76C322.497 135.722 322.612 135.733 322.706 135.791C322.843 135.875 322.985 135.935 323.127 135.971C323.588 136.085 324.077 135.979 324.507 135.668C324.954 135.345 325.28 134.845 325.426 134.261C325.72 133.075 325.167 131.914 324.193 131.671C323.888 131.595 323.562 131.62 323.249 131.739C323.144 131.78 323.024 131.768 322.929 131.707C322.833 131.645 322.772 131.542 322.766 131.429C322.473 126.759 319.312 123.369 315.249 123.369C311.185 123.369 308.024 126.759 307.732 131.429C307.725 131.542 307.664 131.645 307.568 131.707C307.473 131.768 307.354 131.781 307.249 131.739C306.934 131.62 306.607 131.595 306.302 131.671C305.328 131.914 304.776 133.075 305.07 134.261C305.215 134.846 305.541 135.346 305.989 135.668C306.418 135.979 306.908 136.085 307.368 135.971C307.514 135.935 307.651 135.877 307.79 135.791C307.846 135.757 307.911 135.739 307.976 135.739L307.971 135.738Z"
            fill="#FFDBC6"
          />
          <path
            d="M307.507 131.514C311.443 130.772 315.281 128.402 317.742 125.235C318.224 128.048 320.595 130.36 323.198 131.514C323.198 131.514 324.552 121.292 315.242 121.653C305.934 122.013 307.505 131.514 307.505 131.514H307.507Z"
            fill="#FFDBC6"
          />
        </g>
        <path
          d="M259.309 88.8693H197.601C197.404 88.8693 197.244 88.7092 197.244 88.5119V51.9049L186.886 39.8821C186.794 39.777 186.773 39.6266 186.831 39.5004C186.889 39.3726 187.015 39.2917 187.156 39.2917H259.309C259.506 39.2917 259.666 39.4519 259.666 39.6492V88.5119C259.666 88.7092 259.506 88.8693 259.309 88.8693ZM197.958 88.1544H258.952V40.0067H187.934L197.871 51.5394C197.927 51.6041 197.958 51.6865 197.958 51.7723V88.1544Z"
          fill="#080808"
        />
        <path
          d="M232.706 66.4348L244.022 55.1198C245.326 53.8164 245.326 51.7172 244.022 50.4138C242.719 49.1104 240.62 49.1104 239.316 50.4138L228 61.7289L216.684 50.4138C215.38 49.1104 213.281 49.1104 211.978 50.4138C210.674 51.7056 210.674 53.8164 211.978 55.1198L223.294 66.4348L211.978 77.7499C210.674 79.0417 210.674 81.1525 211.978 82.4559C212.624 83.1018 213.477 83.4363 214.331 83.4363C215.184 83.4363 216.038 83.1133 216.684 82.4559L228 71.1408L239.316 82.4559C239.962 83.1018 240.816 83.4363 241.669 83.4363C242.523 83.4363 243.376 83.1133 244.022 82.4559C245.326 81.1525 245.326 79.0533 244.022 77.7499L232.706 66.4348Z"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M259.309 174.869H197.601C197.404 174.869 197.244 174.709 197.244 174.512V137.905L186.886 125.882C186.794 125.777 186.773 125.627 186.831 125.501C186.889 125.373 187.015 125.292 187.156 125.292H259.309C259.506 125.292 259.666 125.452 259.666 125.649V174.512C259.666 174.709 259.506 174.869 259.309 174.869ZM197.958 174.155H258.952V126.007H187.934L197.871 137.539C197.927 137.604 197.958 137.687 197.958 137.772V174.155Z"
          fill="#080808"
        />
        <path
          d="M232.706 152.435L244.022 141.12C245.326 139.817 245.326 137.717 244.022 136.414C242.719 135.111 240.62 135.111 239.316 136.414L228 147.729L216.684 136.414C215.38 135.111 213.281 135.111 211.978 136.414C210.674 137.706 210.674 139.817 211.978 141.12L223.294 152.435L211.978 163.75C210.674 165.042 210.674 167.153 211.978 168.456C212.624 169.102 213.477 169.436 214.331 169.436C215.184 169.436 216.038 169.113 216.684 168.456L228 157.141L239.316 168.456C239.962 169.102 240.816 169.436 241.669 169.436C242.523 169.436 243.376 169.113 244.022 168.456C245.326 167.153 245.326 165.053 244.022 163.75L232.706 152.435Z"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M416.309 88.8694H354.601C354.404 88.8694 354.244 88.7093 354.244 88.512V51.905L343.886 39.8823C343.794 39.7771 343.773 39.6267 343.831 39.5005C343.889 39.3727 344.015 39.2919 344.156 39.2919H416.309C416.506 39.2919 416.666 39.452 416.666 39.6493V88.512C416.666 88.7093 416.506 88.8694 416.309 88.8694ZM354.958 88.1545H415.952V40.0068H344.934L354.871 51.5395C354.927 51.6042 354.958 51.6867 354.958 51.7724V88.1545Z"
          fill="#080808"
        />
        <path
          d="M389.706 66.435L401.022 55.1199C402.326 53.8165 402.326 51.7173 401.022 50.4139C399.719 49.1106 397.62 49.1106 396.316 50.4139L385 61.729L373.684 50.4139C372.38 49.1106 370.281 49.1106 368.978 50.4139C367.674 51.7058 367.674 53.8165 368.978 55.1199L380.294 66.435L368.978 77.75C367.674 79.0419 367.674 81.1526 368.978 82.456C369.624 83.1019 370.477 83.4364 371.331 83.4364C372.184 83.4364 373.038 83.1134 373.684 82.456L385 71.1409L396.316 82.456C396.962 83.1019 397.816 83.4364 398.669 83.4364C399.523 83.4364 400.376 83.1134 401.022 82.456C402.326 81.1526 402.326 79.0534 401.022 77.75L389.706 66.435Z"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M416.309 174.869H354.601C354.404 174.869 354.244 174.709 354.244 174.512V137.905L343.886 125.882C343.794 125.777 343.773 125.627 343.831 125.501C343.889 125.373 344.015 125.292 344.156 125.292H416.309C416.506 125.292 416.666 125.452 416.666 125.649V174.512C416.666 174.709 416.506 174.869 416.309 174.869ZM354.958 174.155H415.952V126.007H344.934L354.871 137.539C354.927 137.604 354.958 137.687 354.958 137.772V174.155Z"
          fill="#080808"
        />
        <path
          d="M389.706 152.435L401.022 141.12C402.326 139.817 402.326 137.717 401.022 136.414C399.719 135.111 397.62 135.111 396.316 136.414L385 147.729L373.684 136.414C372.38 135.111 370.281 135.111 368.978 136.414C367.674 137.706 367.674 139.817 368.978 141.12L380.294 152.435L368.978 163.75C367.674 165.042 367.674 167.153 368.978 168.456C369.624 169.102 370.477 169.436 371.331 169.436C372.184 169.436 373.038 169.113 373.684 168.456L385 157.141L396.316 168.456C396.962 169.102 397.816 169.436 398.669 169.436C399.523 169.436 400.376 169.113 401.022 168.456C402.326 167.153 402.326 165.053 401.022 163.75L389.706 152.435Z"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M275.206 186.57C275.009 186.57 274.849 186.41 274.849 186.213V23.4792C274.849 23.2819 275.009 23.1218 275.206 23.1218C275.403 23.1218 275.563 23.2819 275.563 23.4792V186.213C275.563 186.41 275.403 186.57 275.206 186.57Z"
          fill="#080808"
        />
        <path
          d="M402.773 105.204H158.345C158.148 105.204 157.988 105.044 157.988 104.847C157.988 104.65 158.148 104.489 158.345 104.489H402.773C402.97 104.489 403.13 104.65 403.13 104.847C403.13 105.044 402.97 105.204 402.773 105.204Z"
          fill="#080808"
        />
        <path
          d="M2.80245 235.609C2.80245 235.609 -10.4678 268.336 25.8283 271.786L46.3119 229.403L11.0398 223.565L2.80245 235.609Z"
          fill="white"
        />
        <path
          d="M11.3709 224.345L45.2539 229.953L25.4035 271.026C14.9986 269.947 7.83855 266.288 4.11881 260.151C-1.867 250.278 3.02535 237.017 3.43721 235.946L11.3725 224.345H11.3709ZM11.0398 223.565L2.80245 235.609C2.80245 235.609 -10.4678 268.336 25.8283 271.786L46.3119 229.403L11.0398 223.565Z"
          fill="#080808"
        />
        <path
          d="M7.24719 296.436H127.845L149.258 244.965L192.278 226.027C192.278 226.027 189.682 171.138 166.314 159.848C142.947 148.558 82.2087 151.77 57.1139 160.543C32.019 169.317 5.10548 225.146 2.80225 235.609H33.631L7.24719 296.436Z"
          fill="#FC8543"
        />
        <path
          d="M30.3264 243.708C30.2844 243.708 30.2424 243.7 30.202 243.685C30.0179 243.616 29.9242 243.41 29.9936 243.226L41.6697 212.03C42.508 209.791 42.6388 207.384 42.0493 205.068L41.5695 203.182C41.5211 202.991 41.6358 202.795 41.8264 202.747C42.0169 202.697 42.2108 202.813 42.2608 203.004L42.7405 204.89C43.3656 207.349 43.2267 209.904 42.3368 212.279L30.6607 243.475C30.6074 243.619 30.4701 243.706 30.3264 243.706V243.708Z"
          fill="#080808"
        />
        <path
          d="M139.226 245.693C139.075 245.693 138.935 245.596 138.886 245.445L130.404 219.072C130.098 218.123 129.795 217.298 129.15 216.814C128.806 216.555 128.289 216.463 127.866 216.583C127.663 216.641 127.398 216.772 127.281 217.071C127.21 217.256 127.002 217.346 126.82 217.275C126.635 217.204 126.545 216.997 126.616 216.812C126.789 216.366 127.164 216.039 127.671 215.895C128.309 215.713 129.058 215.85 129.58 216.243C130.457 216.903 130.819 218.03 131.084 218.854L139.566 245.227C139.626 245.414 139.523 245.617 139.335 245.677C139.3 245.688 139.263 245.694 139.226 245.694V245.693Z"
          fill="#080808"
        />
        <path
          d="M141.203 248.413C141.203 248.413 145.296 281.628 169.567 281.643C198.485 281.659 233.742 249.712 257.253 240.514C261.402 244.15 265.821 243.567 268.021 238.063C268.021 238.063 271.264 229.709 264.356 227.866C264.356 227.866 264.426 218.854 252.447 222C252.447 222 273.611 211.625 270.704 205.679C269.337 202.884 252.447 211.391 241.865 215.122C230.518 219.122 192.489 232.24 192.489 232.24L192.082 226.111L141.201 248.412L141.203 248.413Z"
          fill="white"
        />
        <path
          d="M169.588 282H169.565C159.496 281.994 151.333 276.177 145.961 265.18C141.925 256.916 140.857 248.541 140.847 248.457C140.823 248.261 140.962 248.083 141.158 248.059C141.355 248.033 141.531 248.174 141.555 248.37C141.565 248.452 142.621 256.724 146.609 264.883C151.928 275.762 159.651 281.281 169.565 281.287H169.586C188.13 281.287 209.516 267.94 228.388 256.163C238.856 249.63 248.744 243.459 257.122 240.182C257.246 240.133 257.387 240.158 257.487 240.245C259.52 242.027 261.644 242.767 263.466 242.328C265.251 241.9 266.711 240.378 267.69 237.93C267.704 237.893 269.268 233.775 267.784 230.849C267.121 229.545 265.937 228.659 264.266 228.213C264.109 228.17 263.999 228.028 264.001 227.865C264.001 227.834 263.988 224.843 261.685 223.056C259.696 221.513 256.619 221.274 252.54 222.346C252.362 222.393 252.179 222.297 252.115 222.124C252.052 221.953 252.128 221.76 252.292 221.68C252.346 221.654 257.623 219.056 262.473 215.771C268.749 211.52 271.484 208.086 270.386 205.838C269.589 204.206 260.347 208.041 252.922 211.124C249.149 212.691 245.249 214.31 241.984 215.46C230.765 219.415 192.987 232.449 192.607 232.58C192.502 232.617 192.386 232.601 192.294 232.539C192.202 232.478 192.142 232.376 192.136 232.266L191.729 226.137C191.716 225.94 191.864 225.77 192.061 225.757C192.253 225.749 192.428 225.893 192.441 226.09L192.817 231.753C197.101 230.275 231.192 218.509 241.749 214.787C244.993 213.644 248.886 212.028 252.649 210.464C263.364 206.014 269.983 203.395 271.027 205.524C272.322 208.175 269.578 211.823 262.869 216.366C259.963 218.333 256.909 220.056 254.894 221.134C257.978 220.698 260.405 221.154 262.13 222.496C264.306 224.19 264.652 226.75 264.705 227.593C266.449 228.116 267.7 229.102 268.422 230.527C270.051 233.74 268.425 238.011 268.355 238.192C267.286 240.868 265.653 242.537 263.634 243.022C261.631 243.504 259.348 242.759 257.185 240.924C248.91 244.198 239.124 250.306 228.769 256.768C209.818 268.595 188.338 281.999 169.591 281.999L169.588 282Z"
          fill="#080808"
        />
        <path
          d="M258.148 240.193C258.018 240.193 257.894 240.124 257.831 240.001C257.741 239.826 257.808 239.609 257.983 239.519C260.687 238.105 264.909 237.634 265.086 237.615C265.28 237.596 265.458 237.736 265.479 237.932C265.5 238.128 265.359 238.304 265.162 238.325C265.12 238.33 260.895 238.801 258.312 240.151C258.259 240.179 258.203 240.192 258.148 240.192V240.193Z"
          fill="#080808"
        />
        <path
          d="M193.349 242.739C193.166 242.739 193.009 242.598 192.993 242.412L192.116 232.187C192.098 231.989 192.245 231.816 192.441 231.8C192.636 231.776 192.811 231.93 192.827 232.125L193.704 242.351C193.722 242.548 193.575 242.721 193.379 242.738C193.37 242.738 193.358 242.738 193.349 242.738V242.739Z"
          fill="#080808"
        />
        <path
          d="M243.727 224.69C243.584 224.69 243.45 224.602 243.395 224.46C243.324 224.276 243.416 224.069 243.6 223.997C246.56 222.855 249.279 222.268 251.907 221.701L252.142 221.65C252.336 221.608 252.525 221.731 252.567 221.924C252.609 222.116 252.486 222.307 252.294 222.349L252.058 222.399C249.456 222.962 246.767 223.543 243.858 224.664C243.816 224.68 243.773 224.688 243.731 224.688L243.727 224.69Z"
          fill="#080808"
        />
        <path
          d="M253.556 230.071C253.431 230.071 253.31 230.006 253.246 229.89C253.149 229.718 253.208 229.5 253.38 229.403C256.736 227.498 260.837 226.799 264.633 227.488C264.826 227.523 264.956 227.709 264.92 227.904C264.885 228.098 264.702 228.225 264.505 228.191C260.871 227.532 256.944 228.201 253.73 230.026C253.675 230.056 253.614 230.073 253.554 230.073L253.556 230.071Z"
          fill="#080808"
        />
        <path
          d="M145.585 129.63C142.7 119.721 128.259 99.0255 128.259 99.0255L127.229 99.8246L106.332 116.006C106.332 116.006 98.9421 142.867 122.007 145.145C141.927 147.112 148.21 138.644 145.587 129.628L145.585 129.63Z"
          fill="white"
        />
        <path
          d="M127.577 145.795C125.869 145.795 124.006 145.703 121.97 145.502C115.772 144.891 111.172 142.458 108.302 138.272C102.327 129.562 105.947 116.048 105.986 115.914C106.007 115.839 106.05 115.773 106.112 115.726L128.041 98.7457C128.118 98.6858 128.217 98.6599 128.312 98.6745C128.409 98.6891 128.495 98.7424 128.551 98.8233C128.697 99.0304 143.06 119.681 145.929 129.531C147.105 133.57 146.465 137.345 144.131 140.163C141.896 142.861 137.241 145.795 127.581 145.795H127.577ZM106.643 116.216C106.311 117.53 103.39 129.853 108.892 137.869C111.637 141.873 116.061 144.2 122.039 144.791C135.275 146.098 141.058 142.746 143.579 139.705C145.758 137.075 146.349 133.533 145.241 129.73C142.597 120.646 129.979 102.154 128.178 99.5399L106.643 116.216Z"
          fill="#080808"
        />
        <path
          d="M133.324 92.3291C133.324 92.3291 138.535 82.7099 125.285 80.0508C99.8498 74.9476 94.5488 98.8411 93.8058 103.038C87.2192 107.074 85.2357 112.379 85.864 117.821C86.523 123.524 90.4204 127.783 93.0321 129.887C95.1351 131.582 97.6289 132.668 100.161 133.302C98.7046 134.589 99.6963 137.493 101.914 138.622C103.645 139.503 105.393 140.312 107.333 140.391C110.323 140.511 113.327 140.092 116.195 139.241C117.965 138.715 119.776 137.962 120.895 136.49C122.273 134.678 122.302 132.195 122.102 129.926C121.669 125.046 120.438 120.239 118.478 115.754C118.457 115.705 118.434 115.656 118.413 115.608C126.704 115.608 130.811 107.928 131.16 103.893C143.259 98.3801 133.329 92.3307 133.329 92.3307L133.324 92.3291Z"
          fill="#080808"
        />
        <path
          d="M97.3658 157.412C101.231 159.223 109.003 161.061 120.482 155.44C121.446 154.968 122.149 154.086 122.412 153.043C123.32 149.441 125.5 140.871 126.321 138.303C127.369 135.023 123.611 125.213 121.314 122.55C119.017 119.889 111.999 120.344 110.736 124.504C109.473 128.664 111.323 132.718 118.369 131.985L118.158 134.448C117.977 136.553 116.444 138.186 114.458 138.887C110.654 140.229 103.3 138.963 101.354 138.167L95.5778 152.946C94.9027 154.675 95.6893 156.624 97.3675 157.41L97.3658 157.412Z"
          fill="white"
        />
        <path
          d="M95.5777 153.303C95.534 153.303 95.4921 153.295 95.4484 153.279C95.2643 153.208 95.1739 153.001 95.2449 152.817L101.135 137.594C101.171 137.502 101.244 137.428 101.336 137.392C101.428 137.355 101.531 137.358 101.62 137.4C103.663 138.366 109.347 139.974 113.871 138.775C116.252 138.144 117.61 136.639 117.802 134.418L117.978 132.38C114.026 132.693 112.094 131.44 111.164 130.309C109.956 128.844 109.683 126.744 110.395 124.401C110.836 122.95 111.988 121.785 113.64 121.122C115.816 120.25 118.608 120.359 120.429 121.387C120.6 121.484 120.661 121.703 120.564 121.874C120.467 122.046 120.251 122.107 120.078 122.01C118.432 121.08 115.895 120.988 113.907 121.785C112.883 122.196 111.561 123.019 111.08 124.608C110.44 126.715 110.667 128.579 111.716 129.855C112.939 131.34 115.228 131.953 118.335 131.629C118.44 131.621 118.547 131.655 118.623 131.729C118.699 131.804 118.738 131.909 118.728 132.014L118.516 134.478C118.363 136.254 117.466 138.562 114.057 139.464C109.71 140.614 104.327 139.354 101.667 138.203L95.912 153.074C95.8571 153.216 95.7214 153.302 95.5793 153.302L95.5777 153.303Z"
          fill="#080808"
        />
        <path
          d="M122.632 152.98C122.603 152.98 122.574 152.977 122.543 152.969C122.352 152.92 122.236 152.726 122.284 152.534C122.548 151.495 122.869 150.206 123.213 148.821C124.203 144.844 125.436 139.893 125.98 138.193C126.04 138.005 126.238 137.902 126.429 137.962C126.616 138.021 126.72 138.222 126.66 138.411C126.124 140.09 124.895 145.027 123.906 148.994C123.56 150.381 123.239 151.671 122.976 152.71C122.935 152.872 122.79 152.98 122.63 152.98H122.632Z"
          fill="#080808"
        />
        <path
          d="M120.898 129.932C120.787 129.932 120.677 129.881 120.608 129.784C119.748 128.583 118.246 127.833 116.767 127.88H116.756C116.563 127.88 116.405 127.726 116.399 127.534C116.394 127.336 116.547 127.171 116.744 127.167C118.476 127.118 120.176 127.959 121.186 129.37C121.301 129.53 121.263 129.753 121.104 129.868C121.041 129.913 120.968 129.934 120.895 129.934L120.898 129.932Z"
          fill="#080808"
        />
        <path
          d="M64.6693 72.1284L68.7058 84.2939C70.0983 88.4443 69.4509 94.5782 65.3063 95.9743C61.1614 97.3689 58.3622 94.6799 55.7786 89.0159L49.704 78.1464C46.508 72.5133 40.5611 68.7027 36.3549 67.7364C33.2095 67.0141 30.9156 64.3109 30.7531 61.0833L29.6411 39.0311C29.4747 35.7323 30.8701 32.5475 33.4086 30.436C39.4256 27.415 46.0017 25.679 52.7229 25.336C52.7229 25.336 68.8763 24.4866 76.3614 24.0712C79.8522 23.8775 82.9216 26.5633 83.0117 30.0634C83.0491 31.5007 82.5858 32.8385 81.7819 33.9119C81.5409 34.233 81.743 34.6918 82.1442 34.7123L82.8225 34.7467C85.8905 34.9043 88.4701 37.2556 88.7381 40.3196C88.9493 42.7419 87.7431 44.9352 85.8305 46.1165C87.9096 47.1256 89.2149 49.2747 89.3062 51.7931C89.3949 54.2574 87.7685 55.7592 86.038 56.6564C85.1228 57.1312 84.9662 58.3762 85.7596 59.0372C86.7486 59.8611 87.5454 61.2068 87.7288 63.3167C87.9008 66.7181 85.718 68.7065 81.8821 69.3238C75.0225 70.4283 64.6693 72.1284 64.6693 72.1284Z"
          fill="white"
        />
        <path
          d="M43.9338 26.271C40.2597 27.1401 36.6944 28.4381 33.2705 30.1572C33.2499 30.1679 33.2297 30.1799 33.2118 30.1956C30.6132 32.3575 29.1632 35.6649 29.333 39.0452L30.445 61.0973C30.6127 64.432 33.0159 67.2868 36.2875 68.037C40.4737 68.998 46.3339 72.8319 49.4353 78.2969L55.5097 89.165C57.4227 93.3655 60.293 97.9875 65.4057 96.2672C69.8868 94.7583 70.3733 88.2858 69.0005 84.1943L65.0778 72.3756C66.9633 72.0667 75.8657 70.6059 81.931 69.6287C86.1002 68.9585 88.2124 66.7689 88.0375 63.3003C87.8634 61.3152 87.1643 59.8035 85.9564 58.7976C85.6658 58.556 85.5229 58.2016 85.5622 57.8257C85.603 57.4437 85.8337 57.1091 86.1792 56.9307C88.5054 55.7252 89.6926 53.9449 89.6132 51.7815C89.5239 49.3145 88.3434 47.2239 86.4269 46.0854C88.2492 44.748 89.2439 42.5744 89.0452 40.2906C88.7694 37.1202 86.1 34.6025 82.8365 34.4349L82.1582 34.4005C82.0634 34.3955 82.0216 34.3347 82.0047 34.2997C81.9931 34.2751 81.9608 34.1874 82.0286 34.0964C82.9117 32.9191 83.358 31.5218 83.3207 30.0542C83.2761 28.3242 82.541 26.7157 81.2504 25.5244C79.9282 24.303 78.1405 23.6608 76.3437 23.7596C68.9451 24.169 52.8676 25.0164 52.7066 25.0242C49.7263 25.1764 46.7968 25.5923 43.9334 26.2696L43.9338 26.271ZM33.5809 30.6957C39.5862 27.6862 46.0326 25.9867 52.7408 25.6439C52.9032 25.6358 68.981 24.7898 76.3807 24.3787C78.0107 24.2875 79.6333 24.8721 80.8321 25.9798C81.9993 27.0574 82.6628 28.5097 82.703 30.069C82.7373 31.3958 82.3328 32.6591 81.5355 33.7237C81.3525 33.9676 81.319 34.2888 81.4469 34.5616C81.5745 34.833 81.8283 35.0039 82.1288 35.0194L82.8071 35.0538C85.7626 35.2047 88.1798 37.479 88.4295 40.3439C88.6242 42.5681 87.5652 44.6774 85.6677 45.8494C85.5721 45.9081 85.5156 46.0167 85.5207 46.1295C85.5258 46.2423 85.5929 46.3433 85.6954 46.3927C87.6737 47.3535 88.9084 49.3749 88.9968 51.8017C89.0668 53.7364 88.0241 55.2748 85.8958 56.3786C85.3668 56.6524 85.0117 57.1679 84.948 57.7574C84.8857 58.335 85.1148 58.9014 85.5617 59.2734C86.6369 60.1693 87.2633 61.538 87.4216 63.3406C87.6192 67.2527 84.4886 68.5849 81.8334 69.0153C75.0516 70.1072 64.7236 71.8041 64.6207 71.8198C64.5327 71.8377 64.4524 71.8885 64.4059 71.9659C64.3593 72.0433 64.3486 72.1382 64.3775 72.2237L68.414 84.3893C69.6713 88.1387 69.2534 94.3164 65.2086 95.6773C61.5385 96.9164 58.7978 94.8832 56.0615 88.8844L49.9756 77.9916C46.785 72.3687 40.7442 68.4231 36.4253 67.4314C33.4231 66.7416 31.2186 64.1241 31.0642 61.0649L29.9522 39.0127C29.7927 35.8407 31.1488 32.733 33.5805 30.6944L33.5809 30.6957Z"
          fill="#080808"
        />
        <path
          d="M15.2892 30.1872L22.9543 29.8259C25.0137 29.7284 26.7627 31.3222 26.8614 33.3843L28.3491 64.6709C28.4478 66.733 26.8572 68.4832 24.7978 68.5807L17.1327 68.942C15.0733 69.0395 13.3243 67.4457 13.2256 65.3836L11.7378 34.097C11.6391 32.0349 13.2298 30.2847 15.2892 30.1872Z"
          fill="white"
        />
        <path
          d="M14.5328 29.9808C12.6767 30.4199 11.3345 32.1359 11.4271 34.1114L12.9162 65.3976C13.0213 67.6271 14.9207 69.3571 17.1469 69.2519L24.812 68.8906C25.8894 68.8392 26.8855 68.3712 27.6115 67.5717C28.3375 66.7722 28.7095 65.7374 28.6583 64.6556L27.1705 33.369C27.1182 32.2888 26.6505 31.2925 25.8515 30.5651C25.0525 29.8376 24.0189 29.4644 22.9384 29.5151L15.2733 29.8764C15.0197 29.8887 14.7716 29.9243 14.5314 29.9812L14.5328 29.9808ZM25.4171 68.1831C25.211 68.2319 24.9991 68.2618 24.7839 68.2723L17.1188 68.6336C15.233 68.7218 13.626 67.2589 13.535 65.3696L12.0473 34.083C11.9566 32.1951 13.42 30.5832 15.3051 30.4981L22.9702 30.1368C24.856 30.0486 26.4631 31.5115 26.5527 33.4011L28.0404 64.6877C28.0839 65.6025 27.7696 66.4793 27.1543 67.156C26.6842 67.6727 26.0821 68.0273 25.4174 68.1845L25.4171 68.1831Z"
          fill="#080808"
        />
      </g>
      <defs>
        <clipPath id="clip0_825_7607">
          <rect width="444" height="296" fill="white" transform="translate(0 0.436523)" />
        </clipPath>
      </defs>
    </svg>
  ),
  copy: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_888_20158)">
        <path
          d="M12 5.33344H6.66671C5.93033 5.33344 5.33337 5.93039 5.33337 6.66677V12.0001C5.33337 12.7365 5.93033 13.3334 6.66671 13.3334H12C12.7364 13.3334 13.3334 12.7365 13.3334 12.0001V6.66677C13.3334 5.93039 12.7364 5.33344 12 5.33344Z"
          stroke="#FC8543"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.6666 5.33348V4.00014C10.6666 3.64652 10.5262 3.30738 10.2761 3.05733C10.0261 2.80728 9.68691 2.66681 9.33329 2.66681H3.99996C3.64634 2.66681 3.3072 2.80728 3.05715 3.05733C2.8071 3.30738 2.66663 3.64652 2.66663 4.00014V9.33348C2.66663 9.6871 2.8071 10.0262 3.05715 10.2763C3.3072 10.5263 3.64634 10.6668 3.99996 10.6668H5.33329"
          stroke="#FC8543"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_888_20158">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  noUser: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="121"
      viewBox="0 0 120 121"
      fill="none">
      <path
        d="M76.502 101.874C84.4481 101.874 92.2336 99.6362 98.9664 95.4161C105.699 91.196 111.107 85.1646 114.57 78.0129C118.034 70.8613 119.412 62.8787 118.548 54.9797C117.684 47.0807 114.613 39.5849 109.685 33.351C104.758 27.1172 98.174 22.3975 90.6881 19.7326C83.2022 17.0678 75.117 16.5656 67.3588 18.2837C59.6007 20.0017 52.4834 23.8705 46.8225 29.4467C41.1616 35.0229 37.186 42.0811 35.3512 49.8124L29.8128 49.8124L29.8128 42.5201C29.8171 42.0314 29.6857 41.551 29.4332 41.1325C29.1806 40.714 28.8169 40.3739 28.3824 40.1499C27.9479 39.926 27.4598 39.8271 26.9724 39.8642C26.4851 39.9013 26.0176 40.073 25.622 40.3601L1.75125 57.4371C1.4083 57.6812 1.1287 58.0037 0.935774 58.3779C0.742849 58.752 0.642187 59.1669 0.642187 59.5878C0.642187 60.0088 0.742849 60.4236 0.935774 60.7978C1.1287 61.1719 1.4083 61.4945 1.75125 61.7386L25.5297 78.7971C25.924 79.0832 26.3898 79.2547 26.8755 79.2926C27.3612 79.3304 27.848 79.2331 28.2818 79.0114C28.7156 78.7897 29.0796 78.4523 29.3336 78.0365C29.5875 77.6207 29.7214 77.1427 29.7205 76.6555L29.7205 69.2709L35.2589 69.2709C37.4552 78.557 42.7232 86.8292 50.209 92.7469C57.6948 98.6645 66.9597 101.881 76.502 101.874ZM76.502 22.4894C83.7905 22.5222 90.9061 24.7115 96.9526 28.7812C102.999 32.851 107.706 38.6192 110.48 45.3592C113.254 52.0992 113.971 59.5094 112.541 66.6562C111.111 73.8031 107.598 80.3669 102.444 85.5206C97.2903 90.6744 90.7265 94.1876 83.5796 95.6175C76.4328 97.0475 69.0226 96.3303 62.2826 93.5563C55.5426 90.7823 49.7744 86.0756 45.7046 80.0292C41.6349 73.9827 39.4457 66.867 39.4128 59.5786C39.447 49.7677 43.3709 40.3709 50.3238 33.4491C57.2767 26.5273 66.6911 22.6457 76.502 22.6555L76.502 22.4894ZM24.4405 66.6124L24.4405 71.4309L7.82509 59.5047L24.4405 47.5971L24.4405 52.3786C24.438 52.7268 24.5045 53.0721 24.6361 53.3945C24.7677 53.717 24.9618 54.0102 25.2072 54.2573C25.4526 54.5044 25.7444 54.7005 26.0659 54.8343C26.3874 54.9682 26.7322 55.0371 27.0805 55.0371L34.4651 55.0371C34.1451 58.0069 34.1451 61.0026 34.4651 63.9724L27.0805 63.9724C26.7275 63.9723 26.378 64.043 26.0528 64.1802C25.7276 64.3175 25.4332 64.5186 25.1871 64.7716C24.941 65.0246 24.7481 65.3244 24.6198 65.6533C24.4916 65.9822 24.4306 66.3334 24.4405 66.6863L24.4405 66.6124Z"
        fill="#5C5C5C"
      />
      <path
        d="M76.5 62C79.7634 62 82.9535 61.0323 85.6669 59.2193C88.3803 57.4062 90.4952 54.8293 91.744 51.8143C92.9929 48.7993 93.3196 45.4817 92.6829 42.281C92.0463 39.0803 90.4748 36.1403 88.1673 33.8327C85.8597 31.5252 82.9197 29.9537 79.719 29.3171C76.5183 28.6804 73.2007 29.0071 70.1857 30.256C67.1707 31.5048 64.5938 33.6197 62.7808 36.3331C60.9677 39.0465 60 42.2366 60 45.5C60.0052 49.8745 61.7452 54.0683 64.8384 57.1616C67.9317 60.2548 72.1255 61.9948 76.5 62ZM76.5 34.5909C78.6631 34.5871 80.7787 35.2252 82.5789 36.4246C84.3791 37.624 85.7828 39.3306 86.6124 41.3283C87.442 43.326 87.66 45.525 87.239 47.6468C86.8179 49.7685 85.7767 51.7176 84.2471 53.2471C82.7176 54.7767 80.7685 55.8179 78.6467 56.239C76.525 56.6601 74.326 56.442 72.3283 55.6124C70.3306 54.7829 68.6239 53.3791 67.4246 51.5789C66.2252 49.7787 65.5871 47.6631 65.5909 45.5C65.6063 42.6151 66.7619 39.8533 68.8055 37.817C70.8491 35.7806 73.615 34.635 76.5 34.6299V34.5909Z"
        fill="#5C5C5C"
      />
      <path
        d="M48 88.25C49.1206 82.7429 52.1074 77.7931 56.4544 74.2393C60.8014 70.6855 66.2412 68.7462 71.8523 68.75H81.2003C86.8023 68.7583 92.2298 70.7031 96.566 74.2559C100.902 77.8087 103.881 82.7517 105 88.25"
        stroke="#5C5C5C"
        stroke-width="5"
      />
    </svg>
  ),
  private: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_921_16754)">
        <rect width="24" height="24" transform="translate(0 0.000976562)" fill="white" />
        <path
          d="M17 11.001H7C5.89543 11.001 5 11.8964 5 13.001V19.001C5 20.1055 5.89543 21.001 7 21.001H17C18.1046 21.001 19 20.1055 19 19.001V13.001C19 11.8964 18.1046 11.001 17 11.001Z"
          stroke="#080808"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 17.001C12.5523 17.001 13 16.5533 13 16.001C13 15.4487 12.5523 15.001 12 15.001C11.4477 15.001 11 15.4487 11 16.001C11 16.5533 11.4477 17.001 12 17.001Z"
          stroke="#080808"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 11.001V7.00098C8 5.94011 8.42143 4.92269 9.17157 4.17255C9.92172 3.4224 10.9391 3.00098 12 3.00098C13.0609 3.00098 14.0783 3.4224 14.8284 4.17255C15.5786 4.92269 16 5.94011 16 7.00098V11.001"
          stroke="#080808"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_921_16754">
          <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  ),
  'application/msword': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
     c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#8697CB' }}
          d="M18.5,13h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S19.052,13,18.5,13z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M21.5,18h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S22.052,18,21.5,18z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M25.5,18c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71
     c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M37.5,18h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S38.052,18,37.5,18z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M12.5,33c-0.26,0-0.52-0.11-0.71-0.29c-0.18-0.19-0.29-0.45-0.29-0.71c0-0.26,0.11-0.52,0.29-0.71
     c0.37-0.37,1.05-0.37,1.42,0c0.18,0.19,0.29,0.44,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C13.02,32.89,12.76,33,12.5,33z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M24.5,33h-8c-0.552,0-1-0.448-1-1s0.448-1,1-1h8c0.552,0,1,0.448,1,1S25.052,33,24.5,33z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M43.5,18h-2c-0.552,0-1-0.448-1-1s0.448-1,1-1h2c0.552,0,1,0.448,1,1S44.052,18,43.5,18z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M34.5,23h-22c-0.552,0-1-0.448-1-1s0.448-1,1-1h22c0.552,0,1,0.448,1,1S35.052,23,34.5,23z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M43.5,23h-6c-0.552,0-1-0.448-1-1s0.448-1,1-1h6c0.552,0,1,0.448,1,1S44.052,23,43.5,23z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M16.5,28h-4c-0.552,0-1-0.448-1-1s0.448-1,1-1h4c0.552,0,1,0.448,1,1S17.052,28,16.5,28z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M30.5,28h-10c-0.552,0-1-0.448-1-1s0.448-1,1-1h10c0.552,0,1,0.448,1,1S31.052,28,30.5,28z"
        />
        <path
          style={{ fill: '#8697CB' }}
          d="M43.5,28h-9c-0.552,0-1-0.448-1-1s0.448-1,1-1h9c0.552,0,1,0.448,1,1S44.052,28,43.5,28z"
        />
        <path
          style={{ fill: '#0096E6' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M23.5,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937
 s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C19.503,52.984,19.307,53,19.18,53h-3.814V42.924H18.4
 c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C23.395,46.494,23.5,47.08,23.5,47.682z
  M18.633,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244
 c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H18.633z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M33.475,47.914c0,0.848-0.107,1.595-0.321,2.242c-0.214,0.647-0.511,1.185-0.889,1.613
 c-0.378,0.429-0.82,0.752-1.326,0.971s-1.06,0.328-1.661,0.328s-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971
 c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235
 c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.82-0.754,1.326-0.978s1.06-0.335,1.661-0.335s1.155,0.111,1.661,0.335
 s0.948,0.549,1.326,0.978c0.378,0.429,0.674,0.964,0.889,1.606C33.367,46.321,33.475,47.066,33.475,47.914z M29.236,51.729
 c0.337,0,0.658-0.066,0.964-0.198c0.305-0.132,0.579-0.349,0.82-0.649c0.241-0.301,0.431-0.695,0.567-1.183
 s0.209-1.082,0.219-1.784c-0.009-0.684-0.08-1.265-0.212-1.743c-0.132-0.479-0.314-0.873-0.547-1.183s-0.497-0.533-0.793-0.67
 c-0.296-0.137-0.608-0.205-0.937-0.205c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649
 c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75
 c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67C28.596,51.658,28.908,51.729,29.236,51.729z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M42.607,51.975c-0.374,0.364-0.798,0.638-1.271,0.82c-0.474,0.183-0.984,0.273-1.531,0.273
 c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971c-0.378-0.429-0.675-0.966-0.889-1.613
 c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235c0.214-0.643,0.51-1.178,0.889-1.606
 c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335c0.547,0,1.057,0.091,1.531,0.273
 c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.228-0.265-0.481-0.456-0.759-0.574c-0.278-0.118-0.567-0.178-0.868-0.178
 c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649c-0.242,0.306-0.431,0.699-0.567,1.183
 s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.267,0.212,1.75c0.132,0.483,0.314,0.877,0.547,1.183s0.497,0.528,0.793,0.67
 c0.296,0.142,0.608,0.212,0.937,0.212s0.636-0.06,0.923-0.178s0.549-0.31,0.786-0.574L42.607,51.975z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  file: (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '24px', width: '24px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
     c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <circle style={{ fill: '#FFFFFF' }} cx="18.5" cy={47} r={3} />
        <circle style={{ fill: '#FFFFFF' }} cx="28.5" cy={47} r={3} />
        <circle style={{ fill: '#FFFFFF' }} cx="38.5" cy={47} r={3} />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'image/jpeg': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
   c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <circle style={{ fill: '#F3D55B' }} cx="18.931" cy="14.431" r="4.569" />
        <polygon
          style={{ fill: '#26B99A' }}
          points="6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517 	"
        />
        <path
          style={{ fill: '#14A085' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M21.426,42.65v7.848c0,0.474-0.087,0.873-0.26,1.196c-0.173,0.323-0.406,0.583-0.697,0.779
     c-0.292,0.196-0.627,0.333-1.005,0.41C19.085,52.961,18.696,53,18.295,53c-0.201,0-0.436-0.021-0.704-0.062
     c-0.269-0.041-0.547-0.104-0.834-0.191s-0.563-0.185-0.827-0.294c-0.265-0.109-0.488-0.232-0.67-0.369l0.697-1.107
     c0.091,0.063,0.221,0.13,0.39,0.198c0.168,0.068,0.353,0.132,0.554,0.191c0.2,0.06,0.41,0.111,0.629,0.157
     s0.424,0.068,0.615,0.068c0.483,0,0.868-0.094,1.155-0.28s0.439-0.504,0.458-0.95V42.65H21.426z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M25.514,52.932h-1.641V42.855h2.898c0.428,0,0.852,0.068,1.271,0.205
     c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
     c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
     s-0.921,0.232-1.449,0.232h-1.217V52.932z M25.514,44.1v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
     c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567
     c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492C27.5,44.166,27.163,44.1,26.744,44.1H25.514z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M39.5,47.736v3.896c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417
     s-0.583,0.187-0.889,0.232C36.781,52.978,36.479,53,36.178,53c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971
     c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235
     c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335
     c0.547,0,1.057,0.091,1.531,0.273c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.219-0.265-0.47-0.456-0.752-0.574
     c-0.283-0.118-0.574-0.178-0.875-0.178c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649
     c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777
     c0.132,0.501,0.314,0.911,0.547,1.23s0.497,0.556,0.793,0.711c0.296,0.155,0.608,0.232,0.937,0.232c0.1,0,0.234-0.007,0.403-0.021
     c0.168-0.014,0.337-0.036,0.506-0.068c0.168-0.032,0.33-0.075,0.485-0.13c0.155-0.055,0.269-0.132,0.342-0.232v-2.488h-1.709
     v-1.121H39.5z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'video/mp4': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
     c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <path
          style={{ fill: '#FF5364' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M22.4,42.924h1.668V53H22.4v-6.932l-2.256,5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668
 l2.994,6.891L22.4,42.924z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M28.211,53H26.57V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
 s-0.921,0.232-1.449,0.232h-1.217V53z M28.211,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567
 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H28.211z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M38.479,50.648h-4.361V49.35l4.361-6.426h1.668v6.426h1.053v1.299h-1.053V53h-1.668V50.648z
  M38.479,49.35v-4.512L35.58,49.35H38.479z"
          />
        </g>
        <path
          style={{ fill: '#C8BDB8' }}
          d="M24.5,28c-0.166,0-0.331-0.041-0.481-0.123C23.699,27.701,23.5,27.365,23.5,27V13
     c0-0.365,0.199-0.701,0.519-0.877c0.321-0.175,0.71-0.162,1.019,0.033l11,7C36.325,19.34,36.5,19.658,36.5,20
     s-0.175,0.66-0.463,0.844l-11,7C24.874,27.947,24.687,28,24.5,28z M25.5,14.821v10.357L33.637,20L25.5,14.821z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M28.5,35c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S36.771,35,28.5,35z M28.5,7
     c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S35.668,7,28.5,7z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'application/pdf': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
       c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#CC4B4C' }}
          d="M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326
       c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75
       c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172
       c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562
       c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16
       c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822
       c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198
       c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z
  M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415
       c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174
       c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z
  M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"
        />
        <path
          style={{ fill: '#CC4B4C' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
   c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
   c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
   s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
   c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
   c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492
   c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937
   s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035
   c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z
    M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244
   c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'image/png': (
    <>
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 56 56"
        style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}
        xmlSpace="preserve">
        <g>
          <path
            style={{ fill: '#E9E9E0' }}
            d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
      c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
          />
          <path
            style={{ fill: '#659C35' }}
            d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
          />
          <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
          <g>
            <path
              style={{ fill: '#FFFFFF' }}
              d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
        c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
        c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
        s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
        c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
        c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492
        c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
            />
            <path
              style={{ fill: '#FFFFFF' }}
              d="M31.316,42.924V53h-1.668l-3.951-6.945V53h-1.668V42.924h1.668l3.951,6.945v-6.945H31.316z"
            />
            <path
              style={{ fill: '#FFFFFF' }}
              d="M41.16,47.805v3.896c-0.21,0.265-0.444,0.48-0.704,0.649s-0.533,0.308-0.82,0.417
        S39.052,52.954,38.747,53c-0.306,0.046-0.608,0.068-0.909,0.068c-0.602,0-1.155-0.109-1.661-0.328s-0.948-0.542-1.326-0.971
        c-0.378-0.429-0.675-0.966-0.889-1.613c-0.214-0.647-0.321-1.395-0.321-2.242s0.107-1.593,0.321-2.235
        c0.214-0.643,0.51-1.178,0.889-1.606c0.378-0.429,0.822-0.754,1.333-0.978c0.51-0.224,1.062-0.335,1.654-0.335
        c0.547,0,1.057,0.091,1.531,0.273c0.474,0.183,0.897,0.456,1.271,0.82l-1.135,1.012c-0.219-0.265-0.47-0.456-0.752-0.574
        c-0.283-0.118-0.574-0.178-0.875-0.178c-0.337,0-0.659,0.063-0.964,0.191c-0.306,0.128-0.579,0.344-0.82,0.649
        c-0.242,0.306-0.431,0.699-0.567,1.183s-0.21,1.075-0.219,1.777c0.009,0.684,0.08,1.276,0.212,1.777
        c0.132,0.501,0.314,0.911,0.547,1.23s0.497,0.556,0.793,0.711c0.296,0.155,0.608,0.232,0.937,0.232c0.1,0,0.234-0.007,0.403-0.021
        c0.168-0.014,0.337-0.036,0.506-0.068c0.168-0.032,0.33-0.075,0.485-0.13c0.155-0.055,0.269-0.132,0.342-0.232v-2.488h-1.709
        v-1.121H41.16z"
            />
          </g>
          <circle style={{ fill: '#F3D55B' }} cx="18.931" cy="14.431" r="4.569" />
          <polygon
            style={{ fill: '#88C057' }}
            points="6.5,39 17.5,39 49.5,39 49.5,28 39.5,18.5 29,30 23.517,24.517 	"
          />
        </g>
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    </>
  ),
  'application/vnd.ms-powerpoint': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
     c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#F6712E' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M17.581,53H15.94V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
 s-0.921,0.232-1.449,0.232h-1.217V53z M17.581,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567
 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H17.581z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M25.853,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
 c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
 c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
 s-0.921,0.232-1.449,0.232h-1.217V53z M25.853,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
 c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567
 c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H25.853z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M39.606,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H39.606z"
          />
        </g>
        <path style={{ fill: '#C8BDB8' }} d="M39.5,30h-24V14h24V30z M17.5,28h20V16h-20V28z" />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M20.499,35c-0.175,0-0.353-0.046-0.514-0.143c-0.474-0.284-0.627-0.898-0.343-1.372l3-5
     c0.284-0.474,0.898-0.627,1.372-0.343c0.474,0.284,0.627,0.898,0.343,1.372l-3,5C21.17,34.827,20.839,35,20.499,35z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M34.501,35c-0.34,0-0.671-0.173-0.858-0.485l-3-5c-0.284-0.474-0.131-1.088,0.343-1.372
     c0.474-0.283,1.088-0.131,1.372,0.343l3,5c0.284,0.474,0.131,1.088-0.343,1.372C34.854,34.954,34.676,35,34.501,35z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M27.5,16c-0.552,0-1-0.447-1-1v-3c0-0.553,0.448-1,1-1s1,0.447,1,1v3C28.5,15.553,28.052,16,27.5,16
     z"
        />
        <rect x="17.5" y={16} style={{ fill: '#D3CCC9' }} width={20} height={12} />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'text/plain': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
       c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#95A5A5' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M21.867,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H21.867z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M28.443,48.105L31,53h-1.9l-1.6-3.801h-0.137L25.641,53h-1.9l2.557-4.895l-2.721-5.182h1.873
   l1.777,4.102h0.137l1.928-4.102h1.873L28.443,48.105z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M40.529,42.924v1.121h-3.008V53h-1.654v-8.955h-3.008v-1.121H40.529z"
          />
        </g>
        <path
          style={{ fill: '#C8BDB8' }}
          d="M18.5,13h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h6c0.553,0,1,0.448,1,1S19.053,13,18.5,13z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M21.5,18h-9c-0.553,0-1-0.448-1-1s0.447-1,1-1h9c0.553,0,1,0.448,1,1S22.053,18,21.5,18z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M25.5,18c-0.26,0-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.44-0.29-0.71s0.109-0.52,0.3-0.71
       c0.36-0.37,1.04-0.37,1.41,0c0.18,0.19,0.29,0.45,0.29,0.71c0,0.26-0.11,0.52-0.29,0.71C26.02,17.89,25.76,18,25.5,18z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M37.5,18h-8c-0.553,0-1-0.448-1-1s0.447-1,1-1h8c0.553,0,1,0.448,1,1S38.053,18,37.5,18z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M12.5,33c-0.26,0-0.521-0.11-0.71-0.29c-0.181-0.19-0.29-0.45-0.29-0.71
       c0-0.26,0.109-0.52,0.29-0.71c0.37-0.37,1.05-0.37,1.42,0.01c0.18,0.18,0.29,0.44,0.29,0.7c0,0.26-0.11,0.52-0.29,0.71
       C13.02,32.89,12.76,33,12.5,33z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M24.5,33h-8c-0.553,0-1-0.448-1-1s0.447-1,1-1h8c0.553,0,1,0.448,1,1S25.053,33,24.5,33z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M43.5,18h-2c-0.553,0-1-0.448-1-1s0.447-1,1-1h2c0.553,0,1,0.448,1,1S44.053,18,43.5,18z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M34.5,23h-22c-0.553,0-1-0.448-1-1s0.447-1,1-1h22c0.553,0,1,0.448,1,1S35.053,23,34.5,23z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M43.5,23h-6c-0.553,0-1-0.448-1-1s0.447-1,1-1h6c0.553,0,1,0.448,1,1S44.053,23,43.5,23z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M16.5,28h-4c-0.553,0-1-0.448-1-1s0.447-1,1-1h4c0.553,0,1,0.448,1,1S17.053,28,16.5,28z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M30.5,28h-10c-0.553,0-1-0.448-1-1s0.447-1,1-1h10c0.553,0,1,0.448,1,1S31.053,28,30.5,28z"
        />
        <path
          style={{ fill: '#C8BDB8' }}
          d="M43.5,28h-9c-0.553,0-1-0.448-1-1s0.447-1,1-1h9c0.553,0,1,0.448,1,1S44.053,28,43.5,28z"
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'application/vnd.ms-excel': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
     c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#91CDA0' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M20.379,48.105L22.936,53h-1.9l-1.6-3.801h-0.137L17.576,53h-1.9l2.557-4.895l-2.721-5.182h1.873
 l1.777,4.102h0.137l1.928-4.102H23.1L20.379,48.105z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M27.037,42.924v8.832h4.635V53h-6.303V42.924H27.037z"
          />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M39.041,50.238c0,0.364-0.075,0.718-0.226,1.06S38.453,51.94,38.18,52.2s-0.611,0.467-1.012,0.622
 c-0.401,0.155-0.857,0.232-1.367,0.232c-0.219,0-0.444-0.012-0.677-0.034s-0.467-0.062-0.704-0.116
 c-0.237-0.055-0.463-0.13-0.677-0.226c-0.214-0.096-0.399-0.212-0.554-0.349l0.287-1.176c0.127,0.073,0.289,0.144,0.485,0.212
 c0.196,0.068,0.398,0.132,0.608,0.191c0.209,0.06,0.419,0.107,0.629,0.144c0.209,0.036,0.405,0.055,0.588,0.055
 c0.556,0,0.982-0.13,1.278-0.39c0.296-0.26,0.444-0.645,0.444-1.155c0-0.31-0.105-0.574-0.314-0.793
 c-0.21-0.219-0.472-0.417-0.786-0.595s-0.654-0.355-1.019-0.533c-0.365-0.178-0.707-0.388-1.025-0.629
 c-0.319-0.241-0.583-0.526-0.793-0.854c-0.21-0.328-0.314-0.738-0.314-1.23c0-0.446,0.082-0.843,0.246-1.189
 s0.385-0.641,0.663-0.882c0.278-0.241,0.602-0.426,0.971-0.554s0.759-0.191,1.169-0.191c0.419,0,0.843,0.039,1.271,0.116
 c0.428,0.077,0.774,0.203,1.039,0.376c-0.055,0.118-0.119,0.248-0.191,0.39c-0.073,0.142-0.142,0.273-0.205,0.396
 c-0.064,0.123-0.119,0.226-0.164,0.308c-0.046,0.082-0.073,0.128-0.082,0.137c-0.055-0.027-0.116-0.063-0.185-0.109
 s-0.167-0.091-0.294-0.137c-0.128-0.046-0.296-0.077-0.506-0.096c-0.21-0.019-0.479-0.014-0.807,0.014
 c-0.183,0.019-0.355,0.07-0.52,0.157s-0.31,0.193-0.438,0.321c-0.128,0.128-0.228,0.271-0.301,0.431
 c-0.073,0.159-0.109,0.313-0.109,0.458c0,0.364,0.104,0.658,0.314,0.882c0.209,0.224,0.469,0.419,0.779,0.588
 c0.31,0.169,0.647,0.333,1.012,0.492c0.364,0.159,0.704,0.354,1.019,0.581s0.576,0.513,0.786,0.854
 C38.936,49.261,39.041,49.7,39.041,50.238z"
          />
        </g>
        <path
          style={{ fill: '#C8BDB8' }}
          d="M23.5,16v-4h-12v4v2v2v2v2v2v2v2v4h10h2h21v-4v-2v-2v-2v-2v-2v-4H23.5z M13.5,14h8v2h-8V14z
M13.5,18h8v2h-8V18z M13.5,22h8v2h-8V22z M13.5,26h8v2h-8V26z M21.5,32h-8v-2h8V32z M42.5,32h-19v-2h19V32z M42.5,28h-19v-2h19V28
     z M42.5,24h-19v-2h19V24z M23.5,20v-2h19v2H23.5z"
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'application/zip': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
       c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#556080' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M25.266,42.924v1.326l-4.799,7.205l-0.273,0.219h5.072V53h-6.699v-1.326l4.799-7.205l0.287-0.219
   h-5.086v-1.326H25.266z"
          />
          <path style={{ fill: '#FFFFFF' }} d="M29.271,53h-1.668V42.924h1.668V53z" />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M33.414,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
   c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
   c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
   s-0.921,0.232-1.449,0.232h-1.217V53z M33.414,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
   c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567
   c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H33.414z"
          />
        </g>
        <g>
          <path
            style={{ fill: '#C8BDB8' }}
            d="M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2
   h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
          />
          <path
            style={{ fill: '#C8BDB8' }}
            d="M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  'application/x-zip-compressed': (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 56 56"
      style={{ enableBackground: 'new 0 0 56 56', height: '26px', width: '26px' }}>
      <g>
        <path
          style={{ fill: '#E9E9E0' }}
          d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
       c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
        />
        <polygon style={{ fill: '#D9D7CA' }} points="37.5,0.151 37.5,12 49.349,12 	" />
        <path
          style={{ fill: '#556080' }}
          d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
        />
        <g>
          <path
            style={{ fill: '#FFFFFF' }}
            d="M25.266,42.924v1.326l-4.799,7.205l-0.273,0.219h5.072V53h-6.699v-1.326l4.799-7.205l0.287-0.219
   h-5.086v-1.326H25.266z"
          />
          <path style={{ fill: '#FFFFFF' }} d="M29.271,53h-1.668V42.924h1.668V53z" />
          <path
            style={{ fill: '#FFFFFF' }}
            d="M33.414,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
   c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
   c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
   s-0.921,0.232-1.449,0.232h-1.217V53z M33.414,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
   c0.196-0.068,0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032c0-0.164-0.023-0.354-0.068-0.567
   c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492c-0.255-0.132-0.593-0.198-1.012-0.198H33.414z"
          />
        </g>
        <g>
          <path
            style={{ fill: '#C8BDB8' }}
            d="M28.5,24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2
   h-4v5c0,2.757,2.243,5,5,5s5-2.243,5-5v-5H28.5z M30.5,29c0,1.654-1.346,3-3,3s-3-1.346-3-3v-3h6V29z"
          />
          <path
            style={{ fill: '#C8BDB8' }}
            d="M26.5,30h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S25.948,30,26.5,30z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  ),
  shared_delete_link: (
    <svg
      width="480"
      height="320"
      viewBox="0 0 480 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_957_10189)">
        <path
          d="M461.417 0.384766H116.478C106.703 0.384766 98.7783 8.32356 98.7783 18.1159V273.59C98.7783 283.382 106.702 291.321 116.478 291.321H479.116V18.1159C479.116 8.32356 471.193 0.384766 461.417 0.384766Z"
          fill="white"
        />
        <path
          d="M348.374 45.5635H229V185.75H348.374V45.5635Z"
          fill="white"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M348.374 45.5635H229V60.3981H348.374V45.5635Z"
          fill="#FC8543"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M342.946 48.8823L334.768 57.079"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M334.768 48.8823L342.946 57.079"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M296.203 131.632L314.192 113.643C316.264 111.571 316.264 108.234 314.192 106.162C312.119 104.09 308.782 104.09 306.71 106.162L288.721 124.151L270.733 106.162C268.661 104.09 265.323 104.09 263.251 106.162C261.179 108.216 261.179 111.571 263.251 113.643L281.24 131.632L263.251 149.621C261.179 151.674 261.179 155.03 263.251 157.102C264.278 158.129 265.635 158.661 266.992 158.661C268.349 158.661 269.706 158.147 270.733 157.102L288.721 139.114L306.71 157.102C307.737 158.129 309.094 158.661 310.451 158.661C311.808 158.661 313.165 158.147 314.192 157.102C316.264 155.03 316.264 151.693 314.192 149.621L296.203 131.632Z"
          fill="#E33C21"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M238.645 66.4854H282.159"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M238.645 76.4619H282.159"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M238.645 86.4185H282.159"
          stroke="#080808"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M479.114 291.705H116.478C106.506 291.705 98.394 283.578 98.394 273.59V18.1158C98.394 8.1259 106.506 0 116.478 0H461.417C471.388 0 479.5 8.12765 479.5 18.1158V291.321C479.5 291.534 479.327 291.705 479.116 291.705H479.114ZM116.478 0.769399C106.93 0.769399 99.1623 8.55082 99.1623 18.1158V273.59C99.1623 283.155 106.93 290.936 116.478 290.936H478.732V18.1158C478.732 8.55082 470.964 0.769399 461.417 0.769399H116.478Z"
          fill="#080808"
        />
        <path
          d="M454.254 280.101H217.292C217.079 280.101 216.908 279.928 216.908 279.717C216.908 279.505 217.081 279.332 217.292 279.332H454.254C460.4 279.332 465.401 274.322 465.401 268.165V22.559C465.401 17.1557 461.013 12.7596 455.62 12.7596H122.157C116.763 12.7596 112.376 17.1557 112.376 22.559V38.1183C112.376 38.3317 112.203 38.503 111.992 38.503C111.78 38.503 111.607 38.3299 111.607 38.1183V22.559C111.607 16.7308 116.341 11.9902 122.157 11.9902H455.621C461.439 11.9902 466.171 16.7308 466.171 22.559V268.165C466.171 274.747 460.824 280.103 454.254 280.103V280.101Z"
          fill="#080808"
        />
        <path
          d="M0.884277 291.128H479.057V292.517C479.057 307.473 466.932 319.614 452 319.614H27.9423C13.0086 319.614 0.886023 307.471 0.886023 292.517V291.128H0.884277Z"
          fill="white"
        />
        <path
          d="M452 320H27.9421C12.8112 320 0.5 307.672 0.5 292.517V291.128C0.5 290.915 0.672855 290.744 0.884123 290.744H479.057C479.27 290.744 479.441 290.917 479.441 291.128V292.517C479.441 307.67 467.131 320 451.999 320H452ZM1.26825 291.515V292.519C1.26825 307.247 13.2337 319.231 27.9404 319.231H452C466.707 319.231 478.672 307.247 478.672 292.519V291.515H1.26825Z"
          fill="#080808"
        />
        <path
          d="M143.602 94.8597C137.356 93.0621 128.694 93.195 127.379 78.8108C125.461 57.8167 121.495 52.924 115.758 49.8779C115.362 49.5824 114.95 49.3008 114.515 49.0438C111.643 47.3494 108.379 46.8353 105.095 46.9612C101.079 46.7583 96.3056 47.4263 91.4622 50.0248C88.8082 50.9358 86.1927 51.9535 83.6278 53.0219C74.4088 56.8602 65.677 61.8158 57.923 67.9046C50.3121 73.8814 43.6458 81.0053 38.6627 89.1015C33.1697 98.0283 28.6912 109.158 32.4434 119.44C33.6987 122.883 35.7782 125.886 38.3606 128.491C38.0184 128.752 37.6779 129.011 37.327 129.275C1.00636 156.609 100.121 189.431 151.574 119.327C151.574 119.327 166.478 101.443 143.605 94.8597H143.602Z"
          fill="#080808"
        />
        <path
          d="M98.8565 208.799L143.616 203.179L147.892 213.417L113.224 230.325C113.224 230.325 96.0541 218.472 98.8547 208.797L98.8565 208.799Z"
          fill="#FC8543"
        />
        <path
          d="M87.6976 244.562C87.6976 244.562 199.395 165.104 233.195 174.38C266.994 183.657 259.369 227.276 239.482 244.104C225.657 255.8 203.769 274.498 141.922 288.926C80.0744 303.354 87.6976 244.56 87.6976 244.56V244.562Z"
          fill="white"
        />
        <path
          d="M124.023 291.591C113.575 291.591 105.2 288.777 99.01 283.168C84.2317 269.775 87.2838 244.763 87.3169 244.511C87.3449 244.299 87.5387 244.152 87.7482 244.179C87.9595 244.205 88.1079 244.399 88.0799 244.61C88.0485 244.857 85.0489 269.48 99.5303 282.6C108.744 290.949 122.978 292.95 141.836 288.552C203.306 274.211 224.81 256.015 239.042 243.974L239.236 243.81C251.613 233.337 258.627 212.951 255.203 197.401C253.431 189.35 248.156 178.885 233.095 174.751C219.965 171.145 192.3 181.046 153.084 203.378C152.901 203.483 152.665 203.418 152.56 203.233C152.456 203.047 152.52 202.813 152.705 202.708C192.664 179.953 219.78 170.297 233.299 174.008C248.731 178.243 254.138 188.976 255.956 197.235C257.683 205.077 256.913 214.266 253.789 223.113C250.739 231.751 245.747 239.31 239.734 244.397L239.54 244.562C232.456 250.556 223.639 258.017 208.684 265.942C190.983 275.324 169.174 282.965 142.013 289.302C135.467 290.829 129.466 291.591 124.027 291.591H124.023Z"
          fill="#080808"
        />
        <path
          d="M184.717 275.101C184.565 275.101 184.42 275.01 184.359 274.858C178.702 260.698 152.946 233.15 152.686 232.872C152.541 232.716 152.548 232.473 152.704 232.328C152.859 232.183 153.102 232.19 153.247 232.345C153.507 232.623 179.362 260.278 185.071 274.573C185.15 274.771 185.054 274.995 184.856 275.073C184.809 275.092 184.76 275.101 184.713 275.101H184.717Z"
          fill="#080808"
        />
        <path
          d="M112.006 255.45C111.896 255.45 111.787 255.403 111.71 255.312C111.574 255.149 111.595 254.906 111.758 254.77C128.862 240.401 206.22 198.705 206.999 198.287C207.186 198.186 207.42 198.256 207.52 198.445C207.621 198.632 207.549 198.866 207.362 198.966C206.584 199.385 129.295 241.043 112.25 255.361C112.178 255.42 112.089 255.45 112.004 255.45H112.006Z"
          fill="#080808"
        />
        <path
          d="M182.488 285.432C183.351 286.489 183.529 287.949 182.946 289.183C182.363 290.418 181.121 291.205 179.759 291.205H83.2433C73.2456 291.205 63.6215 287.415 56.3023 280.592C45.9117 270.907 30.2465 256.152 17.0379 243.072C2.0623 228.243 -2.66067 205.922 5.00259 186.273C5.11608 185.981 5.22957 185.69 5.3448 185.398C11.8313 168.893 32.0344 162.834 46.4652 173.114C75.5503 193.834 121.598 227.881 139.854 248.221C139.854 248.221 171.038 271.403 182.49 285.431L182.488 285.432Z"
          fill="white"
        />
        <path
          d="M179.758 291.591H83.2435C73.1148 291.591 63.4541 287.786 56.0405 280.876C45.3532 270.914 29.8643 256.316 16.7674 243.346C1.67662 228.404 -3.08127 205.947 4.6431 186.135L4.98532 185.258C8.1264 177.264 14.639 171.276 22.8523 168.832C31.0394 166.396 39.7258 167.842 46.6854 172.801C51.679 176.358 55.9131 179.301 60.0075 182.146C71.8385 190.368 81.1849 196.864 97.2674 210.362C97.4298 210.498 97.4508 210.741 97.3146 210.904C97.1784 211.067 96.9357 211.088 96.7733 210.951C80.717 197.476 71.3845 190.991 59.5692 182.777C55.4731 179.93 51.2373 176.987 46.2402 173.427C39.4744 168.608 31.0306 167.202 23.0723 169.57C15.0878 171.946 8.75671 177.767 5.70118 185.54L5.35896 186.414C-2.25541 205.941 2.43439 228.072 17.3069 242.799C30.3986 255.762 45.8805 270.354 56.5644 280.311C63.8348 287.088 73.3086 290.82 83.2435 290.82H179.76C180.968 290.82 182.082 290.112 182.599 289.019C183.116 287.926 182.955 286.613 182.19 285.677C170.899 271.849 139.933 248.765 139.622 248.535C139.601 248.519 139.582 248.501 139.566 248.484C134.246 242.556 126.129 235.002 115.442 226.031C115.279 225.895 115.258 225.652 115.395 225.489C115.531 225.327 115.773 225.304 115.936 225.442C126.635 234.421 134.768 241.989 140.113 247.94C141.258 248.793 171.594 271.484 182.787 285.191C183.739 286.357 183.938 287.989 183.295 289.351C182.651 290.713 181.265 291.593 179.761 291.593L179.758 291.591Z"
          fill="#080808"
        />
        <path
          d="M101.912 291.591C101.846 291.591 101.779 291.574 101.718 291.539C78.3302 277.76 51.569 253.907 33.5397 230.77C31.1215 227.668 28.6386 224.321 27.1702 220.534C27.0934 220.336 27.1912 220.112 27.3902 220.036C27.5875 219.959 27.811 220.056 27.8878 220.256C29.3178 223.945 31.764 227.24 34.1456 230.297C52.1208 253.363 78.7964 277.141 102.107 290.874C102.291 290.983 102.352 291.219 102.244 291.403C102.172 291.525 102.043 291.593 101.912 291.593V291.591Z"
          fill="#080808"
        />
        <path
          d="M97.0212 283.862C96.9322 283.862 96.8414 283.831 96.768 283.768C96.6074 283.628 96.5917 283.385 96.7314 283.224C108.798 269.357 122.77 257.315 138.255 247.43C138.433 247.316 138.672 247.368 138.786 247.549C138.899 247.729 138.847 247.966 138.669 248.08C123.245 257.925 109.331 269.919 97.311 283.729C97.2342 283.817 97.1277 283.861 97.0212 283.861V283.862Z"
          fill="#080808"
        />
        <path
          d="M85.0017 273.285C84.9056 273.285 84.8079 273.248 84.7345 273.176C84.5826 273.028 84.5791 272.785 84.7258 272.633C97.2832 259.689 111.098 247.828 125.787 237.377C125.96 237.253 126.201 237.295 126.323 237.468C126.445 237.641 126.405 237.882 126.232 238.004C111.581 248.43 97.8017 260.259 85.2775 273.169C85.2025 273.246 85.1012 273.287 85.0017 273.287V273.285Z"
          fill="#080808"
        />
        <path
          d="M171.197 123.701C166.83 117.793 160.159 114.037 152.852 113.362C148.689 112.977 143.472 112.57 137.653 112.271C137.331 113.32 136.884 114.336 136.303 115.294C134.616 118.074 131.974 120.216 129.031 121.545C126.085 122.874 122.789 123.476 119.569 123.088C116.418 122.707 113.418 121.362 111.239 119.01C109.463 117.093 107.333 114.776 106.786 112.264C101.507 112.563 97.3458 113.002 92.3906 113.78C82.9324 115.264 74.6249 120.9 69.6226 129.077C60.4525 144.061 44.5725 170.707 43.7239 192.143C42.355 226.693 98.3567 212.035 98.3567 212.035L161.259 206.249L197.698 178.002C197.698 178.002 186.356 144.209 171.197 123.7V123.701Z"
          fill="#FC8543"
        />
        <path
          d="M94.7584 113.304L96.2897 105.436L119.124 104.262L124.758 113.817L146.406 113.554C153.079 113.474 159.473 116.197 164.053 121.058C177.24 135.056 198.762 154.927 194.749 189.248L154.435 194.175L96.0278 201.614L88.4326 165.896L94.7584 113.306V113.304Z"
          fill="#FC8543"
        />
        <path
          d="M104.869 116.153C102.069 116.153 98.9941 115.886 95.7483 115.184C95.5405 115.139 95.4096 114.934 95.4532 114.726C95.4969 114.518 95.7011 114.385 95.9107 114.431C109.261 117.314 119.636 112.735 119.739 112.687C119.932 112.6 120.159 112.687 120.247 112.88C120.334 113.074 120.247 113.301 120.055 113.388C119.974 113.425 113.811 116.151 104.868 116.151L104.869 116.153Z"
          fill="#FFEBE0"
        />
        <path
          d="M94.3096 83.9745L99.5005 105.273L116.933 104.378C116.933 104.378 116.557 103.426 113.392 91.6213C110.226 79.8163 94.3113 83.9745 94.3113 83.9745H94.3096Z"
          fill="white"
        />
        <path
          d="M95.1592 77.4677C93.9911 76.1737 91.8331 76.039 90.3874 77.013C88.9417 77.987 88.2432 79.8685 88.4755 81.5962C88.7077 83.3256 89.7762 84.8749 91.1748 85.9171C92.5716 86.9592 94.274 87.5293 95.9956 87.8056C100.347 97.0226 111.533 99.4777 116.492 96.9789C120.62 94.898 121.191 87.2513 120.7 82.1855C119.9 73.9319 117.709 69.6792 115.429 63.0886C112.797 62.954 110.131 62.8806 107.558 63.4436C104.984 64.0049 102.477 65.2674 100.884 67.3676C98.9131 69.9678 98.5919 73.4773 98.9236 76.7245C99.0284 77.7422 99.6046 81.138 97.7381 81.0086C96.4844 80.9212 95.8995 78.286 95.1592 77.4677Z"
          fill="white"
        />
        <path
          d="M111.998 98.2834C110.179 98.2834 108.195 97.9477 106.247 97.2762C103.507 96.3319 98.5257 93.8961 95.7338 88.1518C93.8255 87.8196 92.2156 87.1726 90.9445 86.2248C89.3661 85.048 88.3273 83.3798 88.095 81.6469C87.8331 79.6972 88.6677 77.7055 90.1728 76.6913C91.821 75.5809 94.1869 75.8117 95.444 77.2071C95.7408 77.5359 95.994 78.0745 96.2629 78.6445C96.6697 79.5083 97.1743 80.582 97.7645 80.6222C98.0037 80.6397 98.1783 80.5802 98.3145 80.4386C98.9029 79.8196 98.6741 77.8996 98.5764 77.0795C98.5624 76.9588 98.5484 76.8504 98.5397 76.7612C98.1241 72.7027 98.8086 69.4642 100.576 67.1315C102.077 65.152 104.527 63.7059 107.472 63.0642C110.116 62.4871 112.861 62.5693 115.445 62.7022C115.602 62.711 115.736 62.8124 115.789 62.961C116.272 64.3617 116.754 65.6557 117.219 66.9077C118.949 71.573 120.445 75.6001 121.079 82.1453C121.631 87.8388 120.805 95.2303 116.662 97.3199C115.389 97.9617 113.772 98.2817 111.996 98.2817L111.998 98.2834ZM92.5351 76.7542C91.8629 76.7542 91.1785 76.9431 90.6006 77.333C89.333 78.1864 88.6311 79.879 88.8563 81.5455C89.0623 83.0738 89.9895 84.5549 91.4037 85.6093C92.619 86.5151 94.1834 87.1254 96.0551 87.4261C96.1808 87.4454 96.2873 87.5276 96.3415 87.6412C98.9937 93.2613 103.842 95.6342 106.496 96.5488C110.158 97.8113 113.92 97.8428 116.318 96.6345C119.871 94.8421 120.885 88.1046 120.314 82.2222C119.689 75.7767 118.21 71.7916 116.499 67.1787C116.061 65.9949 115.607 64.7743 115.15 63.4611C112.693 63.3387 110.102 63.2828 107.638 63.8196C104.871 64.4246 102.58 65.7676 101.19 67.6001C99.5437 69.7719 98.9099 72.8286 99.3062 76.6843C99.3149 76.77 99.3271 76.8731 99.3411 76.9903C99.4703 78.0745 99.7095 80.0906 98.8714 80.9719C98.5781 81.2797 98.1783 81.4231 97.7121 81.3934C96.6732 81.3217 96.0865 80.0749 95.568 78.975C95.3253 78.4592 95.0948 77.9713 94.8748 77.7265C94.2986 77.0865 93.4274 76.756 92.5369 76.756L92.5351 76.7542Z"
          fill="#080808"
        />
        <path
          d="M97.1432 85.7C97.021 85.7 96.9005 85.6406 96.8254 85.5322C95.9297 84.2189 94.4526 83.3184 92.876 83.1243C92.6647 83.098 92.5163 82.9057 92.5407 82.6941C92.5669 82.4843 92.7607 82.3304 92.9702 82.3601C94.7616 82.5822 96.4413 83.6052 97.4592 85.0985C97.5797 85.2734 97.5343 85.5129 97.358 85.6336C97.2916 85.679 97.2165 85.7018 97.1415 85.7018L97.1432 85.7Z"
          fill="#080808"
        />
        <path
          d="M90.9797 96.0104C89.4275 96.0104 88.2018 94.6622 87.8927 93.2948C87.5313 91.6965 88.1616 90.1332 88.7553 89.1033C89.7767 87.3284 91.3533 85.8526 93.1919 84.9503C93.3839 84.8558 93.6127 84.9363 93.707 85.1269C93.8012 85.3175 93.7209 85.5483 93.5306 85.6427C91.8282 86.4786 90.3686 87.8443 89.4222 89.488C88.8984 90.399 88.338 91.7682 88.6435 93.1251C88.888 94.2093 89.9041 95.3214 91.1211 95.2357C91.7759 95.1885 92.4533 94.7881 92.9806 94.1376C93.4835 93.5168 93.817 92.7492 94.1382 92.0078C94.222 91.8119 94.449 91.7227 94.6446 91.8084C94.8384 91.8923 94.9292 92.1197 94.8436 92.3155C94.5014 93.1059 94.147 93.9225 93.5778 94.6237C92.9178 95.4386 92.0413 95.9422 91.177 96.0051C91.1124 96.0104 91.046 96.0121 90.9832 96.0121L90.9797 96.0104Z"
          fill="#FFEBE0"
        />
        <path
          d="M99.0743 205.055C98.6448 207.965 101.585 210.212 104.27 209.021C109.758 206.585 115.705 205.356 121.706 205.417L147.671 205.677C147.671 205.677 149.698 172.161 112.988 176.211C112.988 176.211 101.912 185.865 99.0725 205.055H99.0743Z"
          fill="white"
        />
        <path
          d="M128.547 206.192C128.528 206.192 128.51 206.192 128.491 206.188C128.281 206.158 128.135 205.963 128.166 205.751C128.435 203.904 128.002 201.851 126.946 199.97C126.059 198.387 124.744 196.892 122.926 195.401C122.584 195.121 122.218 194.832 121.809 194.652C121.615 194.567 121.526 194.339 121.612 194.145C121.697 193.951 121.924 193.862 122.118 193.948C122.616 194.166 123.031 194.491 123.414 194.804C125.306 196.357 126.68 197.924 127.616 199.592C128.755 201.621 129.219 203.848 128.926 205.861C128.898 206.052 128.734 206.19 128.545 206.19L128.547 206.192Z"
          fill="#080808"
        />
        <path
          d="M136.94 205.711C136.752 205.711 136.587 205.572 136.56 205.38C136.245 203.163 135.795 200.57 134.829 198.146C133.834 195.647 132.374 193.61 130.609 192.251C130.44 192.122 130.408 191.881 130.537 191.711C130.667 191.541 130.908 191.51 131.077 191.641C132.952 193.084 134.497 195.235 135.543 197.861C136.539 200.36 136.999 203.011 137.321 205.273C137.35 205.483 137.204 205.679 136.994 205.709C136.977 205.712 136.958 205.712 136.94 205.712V205.711Z"
          fill="#080808"
        />
        <path
          d="M143.664 205.711C143.648 205.711 143.633 205.711 143.619 205.709C143.407 205.684 143.257 205.492 143.282 205.28C144.408 195.834 138.239 189.964 138.178 189.905C138.023 189.76 138.014 189.517 138.159 189.361C138.304 189.205 138.547 189.197 138.702 189.342C138.767 189.403 145.216 195.542 144.046 205.371C144.024 205.567 143.858 205.711 143.666 205.711H143.664Z"
          fill="#080808"
        />
        <path
          d="M168.215 144.507C159.516 130.346 148.268 112.36 143.446 106.032C135.054 95.017 124.488 89.6242 121.965 90.5142C119.442 91.4025 130.536 104.264 130.536 104.264C130.536 104.264 122.637 97.7658 121.965 107.485C121.965 107.485 115.916 106.338 116.096 112.18C116.096 112.18 112.997 111.386 113.355 116.28C113.711 121.175 119.126 127.751 119.377 120.785L129.694 134.23C129.694 134.23 132.064 146.11 136.982 160.21C148.738 158.622 159.912 152.993 168.215 144.51V144.507Z"
          fill="white"
        />
        <path
          d="M194.66 172.924C192.624 169.759 190.264 166.821 187.482 164.352L179.704 163.385C179.704 163.385 174.658 154.995 168.217 144.509C159.914 152.991 148.74 158.62 136.984 160.208C143.942 180.153 155.998 204.541 173.682 206.052C195.669 207.93 196.067 185.334 194.662 172.924H194.66Z"
          fill="#FC8543"
        />
        <path
          d="M166.559 204.522C166.505 204.522 166.451 204.511 166.399 204.487C152.445 198.08 142.679 177.446 136.943 161.266C136.872 161.065 136.977 160.844 137.177 160.775C137.376 160.703 137.598 160.808 137.668 161.009C143.353 177.049 153.008 197.491 166.718 203.787C166.912 203.877 166.996 204.106 166.907 204.298C166.842 204.44 166.702 204.522 166.558 204.522H166.559Z"
          fill="#FFEBE0"
        />
        <path
          d="M179.702 163.77C179.571 163.77 179.443 163.703 179.372 163.583C179.321 163.499 174.221 155.018 167.822 144.603C167.71 144.421 167.766 144.185 167.947 144.073C168.127 143.961 168.365 144.017 168.476 144.199C174.877 154.618 179.979 163.1 180.03 163.184C180.14 163.366 180.08 163.602 179.899 163.712C179.836 163.751 179.768 163.768 179.702 163.768V163.77Z"
          fill="#FFEBE0"
        />
        <path
          d="M211.078 210.759H116.367C115.806 210.759 115.244 210.616 114.783 210.296C113.701 209.549 113.324 208.215 113.753 207.068C114.871 204.721 117.179 203.896 120.59 203.896H217.294L216.038 207.312C215.265 209.384 213.288 210.759 211.078 210.759Z"
          fill="#080808"
        />
        <path
          d="M211.614 210.759C213.508 210.759 215.211 209.603 215.913 207.841L232.68 165.686C233.125 164.567 232.987 163.301 232.313 162.304C231.639 161.308 230.514 160.711 229.313 160.711H171.105C167.597 160.711 164.47 162.925 163.298 166.237L147.56 210.761H211.616L211.614 210.759Z"
          fill="#080808"
        />
        <path
          d="M212.977 204.695H155.266C155.053 204.695 154.882 204.522 154.882 204.31C154.882 204.098 155.055 203.925 155.266 203.925H212.977C213.191 203.925 213.362 204.097 213.362 204.31C213.362 204.523 213.189 204.695 212.977 204.695Z"
          fill="white"
        />
        <path
          d="M68.7406 177.203C68.5311 177.203 68.36 177.035 68.3565 176.825C68.353 176.612 68.5206 176.437 68.7336 176.433L111.08 175.629C111.291 175.622 111.467 175.793 111.471 176.007C111.474 176.22 111.307 176.395 111.094 176.399L68.7476 177.203H68.7406Z"
          fill="#FFEBE0"
        />
        <path
          d="M82.8837 174.797C82.847 174.797 82.8103 174.792 82.7737 174.781C82.5711 174.72 82.4541 174.505 82.5153 174.302C84.0587 169.152 86.1889 164.172 88.8446 159.5C89.3928 158.534 90.2728 157.263 91.6085 157.263C91.6312 157.263 91.6539 157.263 91.6783 157.263C91.8914 157.27 92.0572 157.449 92.0502 157.66C92.0433 157.868 91.8721 158.033 91.6661 158.033C91.6469 158.033 91.6295 158.033 91.6102 158.033C90.8979 158.033 90.2291 158.622 89.5133 159.881C86.8855 164.503 84.7798 169.428 83.2521 174.522C83.2014 174.688 83.0495 174.797 82.8837 174.797Z"
          fill="#FFEBE0"
        />
      </g>
      <defs>
        <clipPath id="clip0_957_10189">
          <rect width="479" height="320" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  ),
  expired_link_no_data: (
    <svg
      width="446"
      height="298"
      viewBox="0 0 446 298"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_957_10735)">
        <path
          d="M238.636 241.253L344.985 241.253C352.077 241.253 357.826 235.495 357.826 228.393V13.2178C357.826 6.11562 352.077 0.358185 344.985 0.358185L238.636 0.358185C231.544 0.358185 225.795 6.11562 225.795 13.2178L225.795 228.393C225.795 235.495 231.544 241.253 238.636 241.253Z"
          fill="white"
        />
        <path
          d="M344.986 241.611H238.636C231.358 241.611 225.437 235.682 225.437 228.393V13.2178C225.437 5.92906 231.358 0 238.636 0H344.986C352.265 0 358.185 5.92906 358.185 13.2178V228.395C358.185 235.684 352.265 241.613 344.986 241.613V241.611ZM238.636 0.716503C231.753 0.716503 226.153 6.32476 226.153 13.2178V228.395C226.153 235.288 231.753 240.896 238.636 240.896H344.986C351.87 240.896 357.47 235.288 357.47 228.395V13.2178C357.47 6.32476 351.87 0.716503 344.986 0.716503H238.636Z"
          fill="#080808"
        />
        <path
          d="M244.09 233.606H339.531C346.058 233.606 351.349 228.307 351.349 221.771V19.1762C351.349 12.6398 346.058 7.3409 339.531 7.3409H244.09C237.563 7.3409 232.272 12.6398 232.272 19.1762L232.272 221.771C232.272 228.307 237.563 233.606 244.09 233.606Z"
          fill="white"
        />
        <path
          d="M339.531 233.964H244.09C237.376 233.964 231.914 228.494 231.914 221.77V19.176C231.914 12.4523 237.376 6.98242 244.09 6.98242H339.531C346.245 6.98242 351.707 12.4523 351.707 19.176V221.77C351.707 228.494 346.245 233.964 339.531 233.964ZM244.09 7.69892C237.771 7.69892 232.629 12.848 232.629 19.176V221.77C232.629 228.098 237.771 233.247 244.09 233.247H339.531C345.85 233.247 350.991 228.098 350.991 221.77V19.176C350.991 12.848 345.85 7.69892 339.531 7.69892H244.09Z"
          fill="#080808"
        />
        <path
          d="M304.183 14.5158H277.943C277.746 14.5158 277.585 14.3562 277.585 14.1576C277.585 13.9589 277.745 13.7993 277.943 13.7993H304.183C304.38 13.7993 304.541 13.9589 304.541 14.1576C304.541 14.3562 304.382 14.5158 304.183 14.5158Z"
          fill="#080808"
        />
        <path
          d="M77.6288 7.13594H66.4105C66.2137 7.13594 66.0527 6.97635 66.0527 6.77769C66.0527 6.57902 66.2121 6.41943 66.4105 6.41943H77.6288C77.8255 6.41943 77.9865 6.57902 77.9865 6.77769C77.9865 6.97635 77.8271 7.13594 77.6288 7.13594Z"
          fill="#080808"
        />
        <path
          d="M51.0604 7.13594H0.357737C0.160981 7.13594 0 6.97635 0 6.77769C0 6.57902 0.159355 6.41943 0.357737 6.41943H51.0604C51.2572 6.41943 51.4181 6.57902 51.4181 6.77769C51.4181 6.97635 51.2588 7.13594 51.0604 7.13594Z"
          fill="#080808"
        />
        <path
          d="M77.6288 22.4758H34.0093C33.8126 22.4758 33.6516 22.3162 33.6516 22.1175C33.6516 21.9189 33.811 21.7593 34.0093 21.7593H77.6288C77.8256 21.7593 77.9866 21.9189 77.9866 22.1175C77.9866 22.3162 77.8272 22.4758 77.6288 22.4758Z"
          fill="#080808"
        />
        <path
          d="M23.7244 22.4758H0.357737C0.160981 22.4758 0 22.3146 0 22.1175C0 21.9205 0.159355 21.7593 0.357737 21.7593H23.7244C23.9212 21.7593 24.0822 21.9189 24.0822 22.1175C24.0822 22.3162 23.9228 22.4758 23.7244 22.4758Z"
          fill="#080808"
        />
        <path d="M260.027 130.376H28.9766L76.5035 297.642H307.553L260.027 130.376Z" fill="white" />
        <path
          d="M307.552 298H76.5034C76.3441 298 76.2026 297.894 76.1587 297.739L28.6317 130.474C28.6009 130.366 28.6236 130.249 28.6903 130.159C28.7586 130.07 28.8643 130.018 28.9748 130.018H260.024C260.183 130.018 260.325 130.123 260.369 130.278L307.896 297.544C307.926 297.652 307.904 297.769 307.837 297.858C307.77 297.948 307.663 298 307.552 298ZM76.7733 297.283H307.079L259.757 130.734H29.4497L76.7717 297.283H76.7733Z"
          fill="#080808"
        />
        <path d="M101.031 196.352H69.373L60.3645 164.648H92.0226L101.031 196.352Z" fill="#FFEBE0" />
        <path d="M140.054 196.352H108.396L99.3872 164.648H131.045L140.054 196.352Z" fill="white" />
        <path
          d="M140.054 196.71H108.396C108.236 196.71 108.095 196.604 108.051 196.449L99.0424 164.746C99.0115 164.638 99.0343 164.521 99.1009 164.431C99.1692 164.342 99.2749 164.29 99.3855 164.29H131.044C131.203 164.29 131.344 164.395 131.388 164.55L140.397 196.254C140.428 196.361 140.405 196.478 140.338 196.568C140.272 196.658 140.164 196.71 140.054 196.71ZM108.666 195.993H139.58L130.775 165.006H99.8603L108.666 195.993Z"
          fill="#080808"
        />
        <path d="M179.076 196.352H147.418L138.41 164.648H170.068L179.076 196.352Z" fill="white" />
        <path
          d="M179.076 196.71H147.418C147.259 196.71 147.117 196.604 147.073 196.449L138.065 164.746C138.034 164.638 138.057 164.521 138.123 164.431C138.192 164.342 138.297 164.29 138.408 164.29H170.066C170.225 164.29 170.367 164.395 170.411 164.55L179.419 196.254C179.45 196.361 179.427 196.478 179.361 196.568C179.292 196.658 179.187 196.71 179.076 196.71ZM147.688 195.993H178.603L169.798 165.006H138.883L147.688 195.993Z"
          fill="#080808"
        />
        <path d="M218.099 196.352H186.441L177.432 164.648H209.09L218.099 196.352Z" fill="white" />
        <path
          d="M218.099 196.71H186.441C186.281 196.71 186.14 196.604 186.096 196.449L177.088 164.746C177.057 164.638 177.079 164.521 177.146 164.431C177.214 164.342 177.32 164.29 177.431 164.29H209.089C209.248 164.29 209.39 164.395 209.433 164.55L218.442 196.254C218.473 196.361 218.45 196.478 218.383 196.568C218.315 196.658 218.209 196.71 218.099 196.71ZM186.711 195.993H217.626L208.82 165.006H177.905L186.711 195.993Z"
          fill="#080808"
        />
        <path d="M257.121 196.352H225.463L216.455 164.648H248.113L257.121 196.352Z" fill="white" />
        <path
          d="M257.121 196.71H225.463C225.304 196.71 225.162 196.604 225.118 196.449L216.11 164.746C216.079 164.638 216.102 164.521 216.169 164.431C216.237 164.342 216.343 164.29 216.453 164.29H248.111C248.271 164.29 248.412 164.395 248.456 164.55L257.464 196.254C257.495 196.361 257.472 196.478 257.406 196.568C257.338 196.658 257.232 196.71 257.121 196.71ZM225.733 195.993H256.648L247.843 165.006H216.928L225.733 195.993Z"
          fill="#080808"
        />
        <path
          d="M111.703 234.269H80.045C79.8856 234.269 79.7442 234.163 79.7003 234.009L70.6918 202.305C70.6609 202.198 70.6837 202.08 70.7503 201.991C70.8186 201.901 70.9243 201.849 71.0349 201.849H102.693C102.852 201.849 102.994 201.955 103.038 202.11L112.046 233.813C112.077 233.921 112.054 234.038 111.988 234.128C111.921 234.217 111.814 234.269 111.703 234.269ZM80.3149 233.553H111.23L102.425 202.566H71.5097L80.3149 233.553Z"
          fill="#080808"
        />
        <path d="M111.703 233.911H80.0451L71.0366 202.208H102.695L111.703 233.911Z" fill="white" />
        <path
          d="M111.703 234.269H80.045C79.8856 234.269 79.7442 234.163 79.7003 234.009L70.6918 202.305C70.6609 202.198 70.6837 202.08 70.7503 201.991C70.8186 201.901 70.9243 201.849 71.0349 201.849H102.693C102.852 201.849 102.994 201.955 103.038 202.11L112.046 233.813C112.077 233.921 112.054 234.038 111.988 234.128C111.921 234.217 111.814 234.269 111.703 234.269ZM80.3149 233.553H111.23L102.425 202.566H71.5097L80.3149 233.553Z"
          fill="#080808"
        />
        <path d="M150.726 233.911H119.068L110.059 202.208H141.717L150.726 233.911Z" fill="white" />
        <path
          d="M150.726 234.269H119.067C118.908 234.269 118.767 234.163 118.723 234.009L109.714 202.305C109.683 202.198 109.706 202.08 109.773 201.991C109.841 201.901 109.947 201.849 110.057 201.849H141.715C141.875 201.849 142.016 201.955 142.06 202.11L151.069 233.813C151.1 233.921 151.077 234.038 151.01 234.128C150.942 234.217 150.836 234.269 150.726 234.269ZM119.337 233.553H150.252L141.447 202.566H110.532L119.337 233.553Z"
          fill="#080808"
        />
        <path d="M189.748 233.911H158.09L149.082 202.208H180.74L189.748 233.911Z" fill="white" />
        <path
          d="M189.748 234.269H158.09C157.931 234.269 157.789 234.163 157.745 234.009L148.737 202.305C148.706 202.198 148.729 202.08 148.796 201.991C148.864 201.901 148.969 201.849 149.08 201.849H180.738C180.897 201.849 181.039 201.955 181.083 202.11L190.091 233.813C190.122 233.921 190.099 234.038 190.033 234.128C189.964 234.217 189.859 234.269 189.748 234.269ZM158.36 233.553H189.275L180.47 202.566H149.555L158.36 233.553Z"
          fill="#080808"
        />
        <path d="M228.771 233.911H197.113L188.104 202.208H219.762L228.771 233.911Z" fill="white" />
        <path
          d="M228.771 234.269H197.113C196.953 234.269 196.812 234.163 196.768 234.009L187.759 202.305C187.729 202.198 187.751 202.08 187.818 201.991C187.886 201.901 187.992 201.849 188.103 201.849H219.761C219.92 201.849 220.061 201.955 220.105 202.11L229.114 233.813C229.145 233.921 229.122 234.038 229.055 234.128C228.987 234.217 228.881 234.269 228.771 234.269ZM197.383 233.553H228.297L219.492 202.566H188.577L197.383 233.553Z"
          fill="#080808"
        />
        <path d="M267.793 233.911H236.135L227.127 202.208H258.785L267.793 233.911Z" fill="white" />
        <path
          d="M267.793 234.269H236.135C235.976 234.269 235.835 234.163 235.791 234.009L226.782 202.305C226.751 202.198 226.774 202.08 226.841 201.991C226.909 201.901 227.015 201.849 227.125 201.849H258.783C258.943 201.849 259.084 201.955 259.128 202.11L268.136 233.813C268.167 233.921 268.145 234.038 268.078 234.128C268.01 234.217 267.904 234.269 267.793 234.269ZM236.405 233.553H267.32L258.515 202.566H227.6L236.405 233.553Z"
          fill="#080808"
        />
        <path d="M122.375 271.47H90.717L81.7085 239.767H113.367L122.375 271.47Z" fill="white" />
        <path
          d="M122.375 271.828H90.7169C90.5575 271.828 90.416 271.722 90.3721 271.568L81.3637 239.864C81.3328 239.757 81.3556 239.639 81.4222 239.55C81.4905 239.46 81.5962 239.408 81.7068 239.408H113.365C113.524 239.408 113.666 239.514 113.71 239.669L122.718 271.372C122.749 271.48 122.726 271.597 122.659 271.687C122.591 271.776 122.486 271.828 122.375 271.828ZM90.9868 271.112H121.902L113.097 240.125H82.1816L90.9868 271.112Z"
          fill="#080808"
        />
        <path d="M122.375 271.47H90.717L81.7085 239.767H113.367L122.375 271.47Z" fill="white" />
        <path
          d="M122.375 271.828H90.7169C90.5575 271.828 90.416 271.722 90.3721 271.568L81.3637 239.864C81.3328 239.757 81.3556 239.639 81.4222 239.55C81.4905 239.46 81.5962 239.408 81.7068 239.408H113.365C113.524 239.408 113.666 239.514 113.71 239.669L122.718 271.372C122.749 271.48 122.726 271.597 122.659 271.687C122.591 271.776 122.486 271.828 122.375 271.828ZM90.9868 271.112H121.902L113.097 240.125H82.1816L90.9868 271.112Z"
          fill="#080808"
        />
        <path d="M161.397 271.47H129.739L120.731 239.767H152.389L161.397 271.47Z" fill="white" />
        <path
          d="M161.397 271.828H129.739C129.58 271.828 129.439 271.722 129.395 271.568L120.386 239.864C120.355 239.757 120.378 239.639 120.445 239.55C120.513 239.46 120.619 239.408 120.729 239.408H152.387C152.547 239.408 152.688 239.514 152.732 239.669L161.74 271.372C161.771 271.48 161.749 271.597 161.682 271.687C161.614 271.776 161.508 271.828 161.397 271.828ZM130.009 271.112H160.924L152.119 240.125H121.204L130.009 271.112Z"
          fill="#080808"
        />
        <path d="M200.42 271.47H168.762L159.753 239.767H191.411L200.42 271.47Z" fill="#FFEBE0" />
        <path
          d="M71.0365 298H0.357516C0.251821 298 0.15263 297.953 0.0843348 297.873C0.0160396 297.792 -0.0132297 297.686 0.00465708 297.582L28.6236 130.316C28.6577 130.12 28.8415 129.99 29.0366 130.023C29.2317 130.057 29.3618 130.241 29.3293 130.436L0.781921 297.284H71.0381C71.2349 297.284 71.3959 297.443 71.3959 297.642C71.3959 297.841 71.2365 298 71.0381 298H71.0365Z"
          fill="#080808"
        />
        <path
          d="M423.41 298H283.065C282.869 298 282.708 297.841 282.708 297.642C282.708 297.443 282.867 297.284 283.065 297.284H423.41C423.607 297.284 423.768 297.443 423.768 297.642C423.768 297.841 423.609 298 423.41 298Z"
          fill="#080808"
        />
        <path
          d="M334.516 183.822H392.177C399.151 183.822 404.811 189.492 404.811 196.475V254.219C404.811 261.203 399.149 266.871 392.177 266.871H334.516C327.542 266.871 321.882 261.201 321.882 254.219V196.475C321.882 189.491 327.544 183.822 334.516 183.822Z"
          fill="#FC8543"
        />
        <path
          d="M368.898 225.498L381.879 212.519C383.374 211.024 383.374 208.616 381.879 207.121C380.383 205.626 377.975 205.626 376.48 207.121L363.5 220.1L350.52 207.121C349.025 205.626 346.617 205.626 345.121 207.121C343.626 208.603 343.626 211.024 345.121 212.519L358.102 225.498L345.121 238.477C343.626 239.959 343.626 242.38 345.121 243.875C345.862 244.616 346.841 245 347.821 245C348.8 245 349.779 244.63 350.52 243.875L363.5 230.896L376.48 243.875C377.221 244.616 378.2 245 379.179 245C380.159 245 381.138 244.63 381.879 243.875C383.374 242.38 383.374 239.972 381.879 238.477L368.898 225.498Z"
          fill="white"
        />
        <path
          d="M111.877 39.2857L105.152 58.9781C104.722 60.2369 103.652 61.1683 102.35 61.4223L99.3547 62.0053C99.3547 62.0053 107.14 78.9311 120.263 76.096C133.385 73.2609 130.499 62.0053 130.499 62.0053L127.723 61.7806C126.061 61.6454 124.922 60.0431 125.339 58.4261L128.46 46.3237C128.46 46.3237 115.744 36.0598 111.879 39.284L111.877 39.2857Z"
          fill="white"
        />
        <path
          d="M117.346 76.7719C105.897 76.7719 99.1028 62.3148 99.0296 62.1553C98.9841 62.0559 98.9857 61.9403 99.0361 61.8426C99.0865 61.7449 99.1792 61.6749 99.2865 61.6537L102.282 61.0707C103.456 60.8428 104.427 59.996 104.814 58.861L111.539 39.1686C111.56 39.1067 111.598 39.0513 111.648 39.009C115.694 35.6381 128.154 45.6187 128.683 46.0454C128.792 46.1333 128.84 46.2782 128.805 46.4134L125.684 58.5158C125.512 59.1834 125.642 59.8901 126.042 60.4519C126.442 61.0137 127.065 61.3687 127.751 61.4241L130.527 61.6488C130.68 61.6619 130.806 61.7693 130.844 61.9175C130.893 62.108 132.011 66.6302 129.471 70.7452C127.71 73.5998 124.635 75.5197 120.336 76.4479C119.307 76.671 118.308 76.7735 117.344 76.7735L117.346 76.7719ZM99.8817 62.2676C101.183 64.8194 108.635 78.2424 120.186 75.746C124.286 74.8602 127.203 73.0526 128.86 70.3739C130.917 67.047 130.392 63.3212 130.205 62.3409L127.694 62.1374C126.796 62.0641 125.982 61.6016 125.46 60.8672C124.938 60.1328 124.767 59.2111 124.992 58.3366L128.053 46.459C124.468 43.6011 115.199 37.221 112.181 39.4991L105.488 59.0922C105.018 60.4682 103.841 61.4958 102.415 61.7726L99.8801 62.266L99.8817 62.2676Z"
          fill="#080808"
        />
        <path
          d="M140.216 14.8008C141.366 20.4823 136.95 25.633 133.128 26.5823C132.993 26.6165 132.857 26.6458 132.725 26.6752C132.644 26.9569 132.543 27.2386 132.416 27.5154C130.914 30.8081 126.613 32.4104 123.001 32.0815C121.954 33.2035 120.59 34.7651 119.144 36.7404C114.526 43.0472 111.248 40.2105 106.449 33.9672C105.81 33.1351 104.89 32.075 104.412 30.3147C103.462 26.8185 105.105 23.6707 105.313 23.2848C106.879 20.3846 108.893 20.4921 113.323 17.5137C120.056 12.9851 120.173 9.52306 125.962 7.56733C127.494 7.0495 129.423 6.42418 131.831 6.86549C135.333 7.50871 139.309 10.3145 140.216 14.8024V14.8008Z"
          fill="#080808"
        />
        <path
          d="M116.461 42.347C116.461 42.347 119.72 49.8817 128.255 48.4894C136.79 47.0971 137.007 36.2258 136.244 24.6738C135.39 25.7649 133.481 26.6051 131.972 27.2484C125.834 29.862 120.313 26.4358 119.5 25.9961C120.962 27.7955 120.965 30.2381 119.733 31.8926C119.053 32.8061 118.074 33.464 115.808 33.5031C115.808 33.5031 114.424 29.8848 111.204 31.9854C107.985 34.0861 109.181 42.9479 116.46 42.347H116.461Z"
          fill="white"
        />
        <path
          d="M126.218 49.0185C119.822 49.0185 116.838 43.8841 116.245 42.7214C113.058 42.8957 110.575 41.2689 109.57 38.3345C108.661 35.6736 109.279 32.8158 111.009 31.6873C112.05 31.0082 113.032 30.8112 113.929 31.1043C115.126 31.4935 115.794 32.6399 116.037 33.1414C118.131 33.06 118.915 32.394 119.445 31.6808C120.63 30.0882 120.538 27.8442 119.221 26.2239C119.113 26.092 119.113 25.9015 119.222 25.7696C119.331 25.6377 119.518 25.6019 119.668 25.6833L119.835 25.7761C125.07 28.7154 129.247 28.0201 131.831 26.9209C133.145 26.3607 135.132 25.5156 135.961 24.4555C136.052 24.3382 136.207 24.2894 136.348 24.3333C136.49 24.3773 136.59 24.5043 136.6 24.6525C137.32 35.5857 137.335 47.3738 128.312 48.8459C127.577 48.9664 126.878 49.0201 126.218 49.0201V49.0185ZM116.461 41.9886C116.603 41.9886 116.733 42.0733 116.79 42.2036C116.918 42.4999 120.045 49.4647 128.198 48.1359C136.418 46.7957 136.585 35.8837 135.94 25.4977C134.981 26.3168 133.538 26.9714 132.114 27.5771C129.554 28.6666 125.52 29.3847 120.505 26.9323C121.287 28.6275 121.136 30.6109 120.022 32.1074C119.133 33.3027 117.874 33.827 115.817 33.8628C115.676 33.8661 115.531 33.7733 115.477 33.6332C115.471 33.6186 114.898 32.1676 113.708 31.7833C113.029 31.5635 112.251 31.7329 111.402 32.2865C109.962 33.2261 109.456 35.7811 110.25 38.1016C110.69 39.388 112.176 42.3436 116.434 41.9902C116.443 41.9902 116.453 41.9902 116.463 41.9902L116.461 41.9886Z"
          fill="#080808"
        />
        <path
          d="M115.959 39.3003C115.811 39.3003 115.671 39.2075 115.621 39.0577C115.437 38.517 115.245 37.9601 114.921 37.5074C114.593 37.0482 114.136 36.7567 113.7 36.7274C113.503 36.7144 113.354 36.5434 113.368 36.3447C113.381 36.1477 113.552 35.9995 113.751 36.0125C114.406 36.0581 115.045 36.4506 115.503 37.0905C115.889 37.6295 116.107 38.2662 116.299 38.828C116.362 39.0153 116.263 39.2189 116.076 39.2824C116.037 39.2954 115.998 39.3019 115.96 39.3019L115.959 39.3003Z"
          fill="#080808"
        />
        <path
          d="M118.022 30.3376C118.022 30.3376 119.412 36.3839 122.422 38.9161C125.432 41.4482 129.837 35.9686 136.696 35.9247C136.696 35.9247 136.885 46.5761 135.356 48.9194C133.426 51.8782 118.113 52.8895 116.318 42.6044C116.318 42.6044 117.947 37.6557 115.666 33.7605L118.021 30.3359L118.022 30.3376Z"
          fill="#080808"
        />
        <path
          d="M159.845 67.1001C155.963 61.8485 133.951 61.0652 128.777 60.7998C128.492 61.7329 128.094 62.635 127.577 63.4867C126.078 65.9586 123.728 67.8606 121.112 69.0412C118.494 70.2234 115.562 70.7576 112.7 70.4123C109.898 70.0736 107.232 68.8784 105.295 66.7891C103.716 65.0858 101.822 63.0275 101.337 60.7949C96.6425 61.062 85.5397 61.4512 81.133 62.1416C72.7246 63.4606 65.4821 68.5608 60.89 75.7373C50.8701 91.3928 39.7283 107.923 39.7283 126.988C39.7283 148.666 91.6944 146.783 91.6944 146.783H142.36L149.046 129.543C149.046 129.543 173.322 85.327 159.845 67.1001Z"
          fill="#FC8543"
        />
        <path
          d="M211.198 74.1154C211.574 78.4779 212.338 82.8013 213.645 86.9831C214.331 89.1815 215.138 91.3489 216.159 93.4154C217.161 95.4427 218.34 97.3806 219.618 99.2451C219.966 99.7532 220.322 100.256 220.683 100.755C237.267 88.0497 249.964 73.5894 249.964 73.5894C259.354 71.7493 256.504 67.1995 256.504 67.1995C259.636 63.306 256.25 61.2672 256.25 61.2672C257.648 55.4717 251.921 55.4863 251.921 55.4863C258.393 51.5944 264.559 43.1902 247.996 49.6126C238.207 53.4085 223.834 62.21 210.954 70.0281C211.005 71.3927 211.079 72.7557 211.196 74.117L211.198 74.1154Z"
          fill="white"
        />
        <path
          d="M221.999 100.095C221.919 100.095 221.841 100.069 221.774 100.016C221.62 99.8918 221.597 99.6654 221.72 99.5124C222.169 98.9538 222.677 98.6705 223.215 98.3692C223.377 98.278 223.545 98.1852 223.719 98.0794C233.913 89.4471 242.443 81.3393 249.798 73.2933C249.85 73.2363 249.92 73.1972 249.995 73.1825C252.047 72.7917 253.987 72.4221 255.382 71.0395C256.07 70.3067 257.099 68.8347 256.175 67.3251C256.089 67.1834 256.11 66.9994 256.229 66.8822C257.626 65.4997 257.632 63.088 256.245 61.5035C255.79 61.0785 255.943 60.4499 256.076 59.8946C256.156 59.5625 256.239 59.2205 256.193 58.9306C255.65 56.3968 253.274 55.9067 251.907 55.8415C251.876 55.8415 251.847 55.835 251.819 55.8269C251.78 55.8138 251.743 55.7943 251.71 55.7699C251.678 55.7438 251.65 55.7145 251.627 55.6787C251.608 55.6477 251.593 55.6135 251.583 55.5761C251.575 55.5468 251.572 55.5175 251.572 55.4882V55.4865V55.4849C251.572 55.4475 251.58 55.41 251.591 55.3742C251.608 55.3286 251.632 55.2862 251.666 55.2504C251.687 55.2276 251.71 55.2081 251.736 55.1918L252.312 54.8221C254.931 53.1449 257.897 51.2445 258.234 48.131C258.132 47.9844 257.862 47.8509 257.715 47.7809C255.403 47.4063 253.17 48.0854 251.011 48.7416C250.722 48.8296 250.434 48.9175 250.148 49.0006C238.807 53.3387 229.065 59.3394 218.751 65.6902C216.811 66.8854 214.806 68.1198 212.813 69.3281C212.644 69.4307 212.424 69.3769 212.322 69.2076C212.219 69.0382 212.273 68.8184 212.442 68.7158C214.432 67.5091 216.437 66.2748 218.376 65.0812C228.719 58.7108 238.489 52.6954 249.917 48.3231C250.227 48.2303 250.513 48.144 250.801 48.0561C253.053 47.3721 255.383 46.6638 257.878 47.0823C257.909 47.0872 257.94 47.0969 257.969 47.11C258.227 47.2288 258.764 47.478 258.933 47.9388C258.951 47.9893 258.959 48.0414 258.954 48.0952C258.663 51.3438 255.837 53.3924 253.323 55.0208C253.284 55.0843 253.183 55.1706 253.053 55.2634C255.14 55.6591 256.489 56.8919 256.899 58.8101C256.971 59.2596 256.865 59.6911 256.774 60.0721C256.657 60.5542 256.593 60.8587 256.761 61.015C258.353 62.8291 258.393 65.5322 256.923 67.1997C257.605 68.5464 257.239 70.1146 255.897 71.546C254.367 73.062 252.279 73.4821 250.248 73.8697C242.885 81.9157 234.352 90.022 224.163 98.6493C224.15 98.6607 224.134 98.6721 224.119 98.6802C223.929 98.7975 223.745 98.9001 223.568 98.9994C223.072 99.2762 222.644 99.5173 222.281 99.9667C222.212 100.055 222.107 100.1 222.003 100.1L221.999 100.095Z"
          fill="#080808"
        />
        <path
          d="M235.272 70.7563C234.615 70.7563 233.952 70.5934 233.366 70.1831C233.205 70.0691 233.165 69.846 233.279 69.6848C233.392 69.5236 233.615 69.4845 233.776 69.5969C234.885 70.3752 236.389 70.0088 237.341 69.4584C238.261 68.9259 239.035 68.1231 239.783 67.348C239.978 67.1461 240.173 66.9425 240.372 66.7455C241.281 65.8352 242.521 64.7572 244.059 64.4901C244.79 64.3631 245.52 64.4299 246.227 64.4934C246.538 64.5211 246.86 64.5504 247.17 64.5618C247.977 64.5895 249.063 64.4722 249.665 63.746C250.429 62.821 249.969 61.2659 249.047 60.4908C248.045 59.6505 246.645 59.4062 245.284 59.2678C241.51 58.8851 238.103 59.1506 235.155 60.0576C234.966 60.1162 234.766 60.0087 234.708 59.8198C234.649 59.631 234.757 59.4307 234.945 59.372C237.984 58.4373 241.489 58.1621 245.357 58.5546C246.834 58.7044 248.357 58.9763 249.508 59.942C250.691 60.9337 251.271 62.9269 250.217 64.2019C249.432 65.1513 248.117 65.3125 247.147 65.2767C246.817 65.2653 246.486 65.2343 246.165 65.2066C245.474 65.1431 244.822 65.0845 244.185 65.1952C242.843 65.4281 241.715 66.4166 240.88 67.2503C240.685 67.4457 240.493 67.6444 240.3 67.8447C239.518 68.6556 238.708 69.4943 237.702 70.0772C237.048 70.455 236.168 70.7563 235.275 70.7563H235.272Z"
          fill="#080808"
        />
        <path
          d="M246.308 67.887C245.731 67.887 245.082 67.7925 244.515 67.4457C243.698 66.9457 243.17 65.7993 243.684 64.8907C243.781 64.7181 243.999 64.6578 244.172 64.7555C244.344 64.8532 244.404 65.0714 244.307 65.244C244.011 65.7684 244.368 66.5158 244.889 66.8334C245.39 67.1411 246.064 67.2323 247.009 67.1249C250.317 66.7454 253.354 64.6871 254.935 61.7527C255.029 61.5785 255.245 61.5133 255.419 61.6078C255.593 61.7022 255.658 61.9188 255.564 62.0931C253.874 65.231 250.627 67.4326 247.09 67.8365C246.86 67.8625 246.591 67.8853 246.308 67.8853V67.887Z"
          fill="#080808"
        />
        <path
          d="M249.853 70.1406C249.775 70.1406 249.697 70.1406 249.619 70.1373C248.734 70.1129 248.081 69.9387 247.564 69.5902C246.85 69.1082 246.482 68.2614 246.669 67.5286C246.718 67.3365 246.913 67.2208 247.105 67.2713C247.297 67.3202 247.412 67.5156 247.362 67.7077C247.235 68.2028 247.568 68.7304 247.964 68.9974C248.364 69.2661 248.895 69.4013 249.638 69.4225C251.721 69.4778 253.79 68.6994 255.317 67.2811C255.461 67.1459 255.687 67.1557 255.822 67.3006C255.957 67.4456 255.948 67.6719 255.803 67.8071C254.198 69.2987 252.04 70.1422 249.853 70.1422V70.1406Z"
          fill="#080808"
        />
        <path
          d="M250.58 72.9643C249.827 72.9643 249.089 72.5165 248.743 71.8472C248.393 71.1714 248.455 70.3035 248.897 69.6847C249.013 69.5234 249.235 69.4876 249.396 69.6016C249.557 69.7172 249.593 69.9403 249.479 70.1015C249.19 70.5054 249.149 71.0737 249.378 71.5166C249.608 71.9579 250.082 72.2576 250.591 72.2478H250.595C250.791 72.2478 250.951 72.4057 250.952 72.6028C250.954 72.7998 250.795 72.9627 250.598 72.9643C250.593 72.9643 250.587 72.9643 250.582 72.9643H250.58Z"
          fill="#080808"
        />
        <path
          d="M212.622 69.0155L199.193 76.7048C191.719 80.9843 182.669 81.4891 174.767 78.0662L157.614 65.2033C153.723 62.9496 138.753 69.3265 137.99 72.4009C137.034 76.257 136.294 80.1668 135.818 84.1125C135.384 87.6999 135.103 91.3052 135.288 94.9187C135.395 97.0095 135.625 99.0825 135.929 101.146C140.659 103.955 171.356 121.449 193.884 116.422C209.393 112.96 227.428 95.7459 227.428 95.7459C227.428 95.7459 227.311 76.5062 212.621 69.0187L212.622 69.0155Z"
          fill="#FC8543"
        />
        <path
          d="M87.0731 143.258C86.6909 145.844 91.6928 147.499 91.6928 147.499H107.194L130.28 143.81C130.28 143.81 132.081 114.023 99.4443 117.622C99.4443 117.622 89.5951 126.202 87.0731 143.257V143.258Z"
          fill="white"
        />
        <path
          d="M113.277 144.286C113.259 144.286 113.243 144.286 113.225 144.282C113.03 144.253 112.894 144.072 112.923 143.877C113.162 142.24 112.776 140.418 111.84 138.749C111.051 137.344 109.884 136.017 108.271 134.693C107.968 134.445 107.643 134.189 107.282 134.03C107.101 133.95 107.019 133.74 107.098 133.558C107.178 133.377 107.389 133.294 107.57 133.374C108.014 133.569 108.399 133.87 108.726 134.137C110.411 135.518 111.633 136.912 112.466 138.397C113.479 140.205 113.894 142.187 113.632 143.979C113.606 144.157 113.453 144.286 113.279 144.286H113.277Z"
          fill="#080808"
        />
        <path
          d="M120.739 143.858C120.564 143.858 120.411 143.729 120.387 143.55C120.109 141.579 119.707 139.277 118.85 137.124C117.967 134.906 116.671 133.097 115.102 131.892C114.946 131.771 114.916 131.547 115.037 131.39C115.157 131.234 115.382 131.205 115.538 131.325C117.208 132.61 118.582 134.523 119.513 136.86C120.4 139.083 120.809 141.439 121.094 143.45C121.122 143.646 120.985 143.828 120.79 143.856C120.774 143.859 120.756 143.859 120.739 143.859V143.858Z"
          fill="#080808"
        />
        <path
          d="M126.717 143.857C126.702 143.857 126.688 143.857 126.675 143.854C126.478 143.831 126.338 143.652 126.362 143.455C127.362 135.069 121.884 129.856 121.829 129.804C121.684 129.669 121.676 129.443 121.811 129.298C121.946 129.153 122.172 129.145 122.317 129.28C122.375 129.334 128.115 134.795 127.073 143.54C127.052 143.722 126.897 143.856 126.719 143.856L126.717 143.857Z"
          fill="#080808"
        />
        <path
          d="M186.652 148.329H102.448C101.949 148.329 101.451 148.2 101.04 147.917C100.077 147.254 99.742 146.067 100.122 145.048C101.116 142.962 103.168 142.229 106.202 142.229H192.178L191.062 145.266C190.375 147.108 188.617 148.329 186.652 148.329Z"
          fill="#080808"
        />
        <path
          d="M187.129 148.329C188.814 148.329 190.327 147.301 190.95 145.735L205.857 108.27C206.252 107.277 206.13 106.15 205.53 105.264C204.93 104.378 203.931 103.847 202.863 103.847H151.111C147.993 103.847 145.212 105.814 144.171 108.758L130.179 148.327H187.129V148.329Z"
          fill="#080808"
        />
        <path
          d="M188.34 142.953H137.031C136.834 142.953 136.673 142.794 136.673 142.595C136.673 142.396 136.833 142.237 137.031 142.237H188.34C188.537 142.237 188.698 142.396 188.698 142.595C188.698 142.794 188.539 142.953 188.34 142.953Z"
          fill="white"
        />
        <path
          d="M60.1063 118.522C59.9112 118.522 59.7535 118.366 59.7486 118.171C59.7453 117.974 59.9014 117.809 60.0998 117.806L97.7483 117.091C97.9418 117.084 98.1093 117.244 98.1126 117.443C98.1158 117.64 97.9597 117.804 97.7614 117.808L60.1128 118.522C60.1128 118.522 60.1079 118.522 60.1063 118.522Z"
          fill="#080808"
        />
        <path
          d="M72.679 116.383C72.6448 116.383 72.6107 116.378 72.5766 116.368C72.3879 116.311 72.2806 116.111 72.3375 115.922C73.7099 111.344 75.6043 106.917 77.967 102.764C78.4646 101.888 79.2727 100.73 80.5004 100.77C80.6972 100.776 80.8533 100.942 80.8468 101.139C80.8403 101.336 80.676 101.489 80.4777 101.486C79.8337 101.463 79.2353 101.984 78.5898 103.119C76.2547 107.226 74.3815 111.602 73.0237 116.129C72.9766 116.283 72.8351 116.384 72.6823 116.384L72.679 116.383Z"
          fill="#080808"
        />
        <path
          d="M261.38 52.9155C264.766 52.9155 267.51 50.1669 267.51 46.7763C267.51 43.3858 264.766 40.6372 261.38 40.6372C257.994 40.6372 255.25 43.3858 255.25 46.7763C255.25 50.1669 257.994 52.9155 261.38 52.9155Z"
          fill="#FC8543"
        />
        <path d="M405.779 100.753H280.782V164.926H405.779V100.753Z" fill="white" />
        <path
          d="M405.779 165.284H280.783C280.586 165.284 280.425 165.125 280.425 164.926V100.753C280.425 100.556 280.584 100.395 280.783 100.395H405.779C405.976 100.395 406.137 100.555 406.137 100.753V164.926C406.137 165.123 405.977 165.284 405.779 165.284ZM281.14 164.568H405.421V101.112H281.14V164.568Z"
          fill="#080808"
        />
        <path
          d="M408.303 105.846C427.228 86.8936 427.228 56.165 408.303 37.2122C389.377 18.2594 358.693 18.2594 339.767 37.2122C320.842 56.165 320.842 86.8936 339.767 105.846C358.693 124.799 389.377 124.799 408.303 105.846Z"
          fill="white"
        />
        <path
          d="M374.035 120.42C347.115 120.42 325.215 98.4885 325.215 71.5301C325.215 44.5716 347.115 22.6401 374.035 22.6401C400.954 22.6401 422.854 44.5716 422.854 71.5301C422.854 98.4885 400.954 120.42 374.035 120.42ZM374.035 23.3566C347.51 23.3566 325.931 44.9673 325.931 71.5301C325.931 98.0928 347.51 119.703 374.035 119.703C400.559 119.703 422.139 98.0928 422.139 71.5301C422.139 44.9673 400.559 23.3566 374.035 23.3566Z"
          fill="#080808"
        />
        <path
          d="M374.035 42.6648C373.838 42.6648 373.677 42.5053 373.677 42.3066V32.6371C373.677 32.44 373.836 32.2788 374.035 32.2788C374.233 32.2788 374.392 32.4384 374.392 32.6371V42.3066C374.392 42.5036 374.233 42.6648 374.035 42.6648Z"
          fill="#080808"
        />
        <path
          d="M374.035 110.782C373.838 110.782 373.677 110.622 373.677 110.423V100.754C373.677 100.557 373.836 100.396 374.035 100.396C374.233 100.396 374.392 100.555 374.392 100.754V110.423C374.392 110.62 374.233 110.782 374.035 110.782Z"
          fill="#080808"
        />
        <path
          d="M344.853 71.8884H335.198C335.001 71.8884 334.84 71.7288 334.84 71.5301C334.84 71.3315 334.999 71.1719 335.198 71.1719H344.853C345.05 71.1719 345.211 71.3315 345.211 71.5301C345.211 71.7288 345.052 71.8884 344.853 71.8884Z"
          fill="#080808"
        />
        <path
          d="M412.872 71.8884H403.216C403.02 71.8884 402.859 71.7288 402.859 71.5301C402.859 71.3315 403.018 71.1719 403.216 71.1719H412.872C413.069 71.1719 413.23 71.3315 413.23 71.5301C413.23 71.7288 413.07 71.8884 412.872 71.8884Z"
          fill="#080808"
        />
        <path
          d="M411.256 53.7394C407.034 44.8971 399.759 37.8021 390.801 33.8027L374.035 71.5282L411.256 53.7394Z"
          fill="#FFEBE0"
        />
        <path
          d="M366.13 89.8152C366.082 89.8152 366.033 89.8054 365.986 89.7842C365.805 89.7044 365.724 89.4927 365.804 89.312L373.708 71.3848C373.721 71.3538 373.739 71.3261 373.76 71.3017L395.917 44.5159C396.042 44.3645 396.268 44.3417 396.421 44.4687C396.574 44.5957 396.595 44.8204 396.468 44.9735L374.344 71.7218L366.46 89.6035C366.402 89.737 366.27 89.8168 366.134 89.8168L366.13 89.8152Z"
          fill="#080808"
        />
        <path d="M299.312 40.2886H291.811V156.956H299.312V40.2886Z" fill="#FFEBE0" />
        <path
          d="M311.551 157.315C311.354 157.315 311.193 157.155 311.193 156.957V83.5443C311.193 83.3472 311.353 83.186 311.551 83.186C311.749 83.186 311.909 83.3456 311.909 83.5443V156.957C311.909 157.154 311.749 157.315 311.551 157.315Z"
          fill="#FFEBE0"
        />
        <path
          d="M325.305 157.315C325.108 157.315 324.947 157.155 324.947 156.956V108.575C324.947 108.378 325.106 108.216 325.305 108.216C325.503 108.216 325.662 108.376 325.662 108.575V156.956C325.662 157.153 325.503 157.315 325.305 157.315Z"
          fill="#FFEBE0"
        />
        <path
          d="M339.056 157.315C338.859 157.315 338.698 157.155 338.698 156.957V118.164C338.698 117.967 338.858 117.806 339.056 117.806C339.255 117.806 339.414 117.966 339.414 118.164V156.957C339.414 157.154 339.255 157.315 339.056 157.315Z"
          fill="#FFEBE0"
        />
        <path
          d="M352.809 157.315C352.613 157.315 352.452 157.155 352.452 156.956V138.814C352.452 138.617 352.611 138.456 352.809 138.456C353.008 138.456 353.167 138.616 353.167 138.814V156.956C353.167 157.154 353.008 157.315 352.809 157.315Z"
          fill="#FFEBE0"
        />
        <path
          d="M366.561 157.315C366.365 157.315 366.204 157.155 366.204 156.956V129.322C366.204 129.125 366.363 128.964 366.561 128.964C366.76 128.964 366.919 129.123 366.919 129.322V156.956C366.919 157.153 366.76 157.315 366.561 157.315Z"
          fill="#FFEBE0"
        />
        <path
          d="M380.315 157.315C380.118 157.315 379.957 157.155 379.957 156.957V138.08C379.957 137.883 380.116 137.722 380.315 137.722C380.513 137.722 380.672 137.881 380.672 138.08V156.957C380.672 157.154 380.513 157.315 380.315 157.315Z"
          fill="#FFEBE0"
        />
        <path
          d="M394.066 157.315C393.869 157.315 393.708 157.155 393.708 156.956V131.615C393.708 131.418 393.868 131.257 394.066 131.257C394.265 131.257 394.424 131.416 394.424 131.615V156.956C394.424 157.154 394.265 157.315 394.066 157.315Z"
          fill="#FFEBE0"
        />
        <path
          d="M286.053 47.1345H272.831C272.634 47.1345 272.473 46.9749 272.473 46.7762C272.473 46.5776 272.632 46.418 272.831 46.418H286.053C286.249 46.418 286.41 46.5776 286.41 46.7762C286.41 46.9749 286.251 47.1345 286.053 47.1345Z"
          fill="#080808"
        />
        <path
          d="M28.9767 110.781H0.357737C0.160981 110.781 0 110.621 0 110.423V33.8041C0 33.607 0.159355 33.4458 0.357737 33.4458C0.556118 33.4458 0.715473 33.6054 0.715473 33.8041V110.066H28.9767C29.1734 110.066 29.3344 110.226 29.3344 110.424C29.3344 110.623 29.175 110.783 28.9767 110.783V110.781Z"
          fill="#080808"
        />
        <path
          d="M445.642 225.705H409.475C409.278 225.705 409.117 225.545 409.117 225.346C409.117 225.148 409.277 224.988 409.475 224.988H445.284V71.8879H428.181C427.985 71.8879 427.824 71.7283 427.824 71.5296C427.824 71.331 427.983 71.1714 428.181 71.1714H445.642C445.839 71.1714 446 71.331 446 71.5296V225.348C446 225.545 445.84 225.706 445.642 225.706V225.705Z"
          fill="#080808"
        />
      </g>
      <defs>
        <clipPath id="clip0_957_10735">
          <rect width="446" height="298" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
};

export const FolderIcon = ({ style = {} }) => (
  <svg
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="url(#pattern0_825_517)" />
    <defs>
      <pattern id="pattern0_825_517" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_825_517" transform="scale(0.00195312)" />
      </pattern>
      <image
        id="image0_825_517"
        width="512"
        height="512"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
